import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import {
  LeadRequest,
  LeadGeneralRequest,
  LeadLivingPlaceRequest,
  LeadSpouseRequest,
  LeadJobRequest,
  LeadCreditBureauRequest,
  LeadReferenceRequest,
  LeadBeneficiaryRequest,
  LeadJobDetailsRequest,
  LeadLibertadRelationRequest,
  LeadAnnotation,
  OfferUpdateRequest,
  ModalInfoPersonal,
  ScheduleInvestigationRequest,
  LeadClientExistantRequest
} from "@/models/requests/lead.interface";
import { ODataBaseResponse, ODataMultipleResponse } from "@/models/responses/odata.response.interface";
import {
  LeadResponse,
  LeadTypeRespose,
  LeadProfilingResponse,
  LeadProfilingSpouseResponse,
  LeadOfferResponse,
  LeadOfferReferenceResponse,
  LeadOfferBeneficiaryResponse,
  LeadOfferJobResponse,
  LeadOfferLibertadRelationResponse,
  OfferResponse,
  OfferAvailableResponse,
  LeadSearchResponse,
  // MotorMessageResponse,
  MotorResultResponse,
  MotorMessageErrorResponse,
  IsOfferPreautorizadoResponse,
  LeadUserResponse,
  LeadDataResponse,
  ReferredClientResponse,
  LeadPLDMatchResponse,
  MotorOfferDataResponse,
  MotorProfilingDataResponse,
  PhoneVerification,
  ConsultaClienteResponse,
  LeadOfferRespose
} from "@/models/responses/lead.interface";
import { ApiService } from "./api.service";
import { FLOW_CRED_REQ_PDF_URL, FLOW_VAL_ID_URL, RECAPTCHA_SITE_KEY, SUSCRIPTION_KEY } from "@/constants/config";
import dayjs from "dayjs";
import { Appointment } from "@/models/requests/appointment.interface";
import { variablesService } from "./variables.service";
import { SUBSCRIPTION } from "@/store/types";
//import { ThumbFingerBounds } from "@identy/identy-finger";
//import { Modal } from "ant-design-vue";
import { DocumentKindResponse } from "@/models/responses/documentation.interface";
import { values } from "lodash-es";
import { LeadPrincipalImssRequest } from "@/models/requests/imss.interface";

interface LeadHeadODataResponse extends ODataBaseResponse {
  rs_montoseguro: any;
  leadid: string;
  rs_folio: string;
  firstname: string;
  rs_segundonombre?: string;
  middlename: string;
  lastname: string;
  rs_nipenviado: string;
  rs_codigoverificador: string;
  rs_fechanacimiento: string;
  rs_tipocliente: number;
  rs_numcredito: string;
  rs_origenprospecto: number;
  rs_buroautenticado: number;
  rs_bcautenticado: boolean;
  mobilephone?: string;
  emailaddress1?: string;
  //se agregan para imss
  rs_edad?: number;
  rs_validarmediocontacto?: number;
  _rs_tipoconvenioid_value?: string;
  _rs_finalidadid_value?: string;
  rs_tipoproyecto: number;
  _rs_sucursalprospectoid_value: string;
  rs_periodopago: number;
  statecode: number;
  statuscode: number;
  rs_matricula: string;
  _rs_estadodelegacionid_value?: string;
  //se agregan para cliente existente
  rs_montorequerido?: number;
  rs_plazoquincenal?: number;
  rs_pagofijo?: number;
  rs_catsiniva?: number;
  // _rs_comprobanteingresosid_value?: string;
  _rs_tipoingreso_value?: string;
  rs_finalidaddelosrecursos: number;
  rs_coincidenciapld: number;
  rs_afiliacionclublibertad?: boolean;
  rs_tipofolio: number;
  _rs_ocupacionid_value: string;
  rs_instrumentomonetariomanejacuenta: number;
  _rs_sujetocreditoid_value: string;
  _rs_tipotramiteid_value: string;

  rs_lead_quote_prospectoid?: {
    _rs_productoid_value: string;
    rs_productoid: {
      productid: string;
      rs_aplicapreautorizado?: boolean;
    };
  };
  rs_origen?: number;
  _rs_sucursalid_value?: string;
}

interface LeadProfilingODataResponse extends ODataBaseResponse {
  leadid: string;
  rs_folio: string;
  firstname: string;
  rs_segundonombre?: string;
  middlename: string;
  lastname: string;
  rs_fechanacimiento: string;
  _rs_sujetocreditoid_value: string;
  _rs_tipotramiteid_value: number;
  emailaddress1: string;
  mobilephone: string;
  // General
  rs_genero: number;
  _rs_lugarnacimientoid_value: string;
  rs_nacionalidad: number;
  telephone2: string;
  _rs_nivelestudios_value: string;
  rs_curp: string;
  rs_rfc: string;
  rs_nipenviado: string;
  // Living
  address1_line1: string;
  address1_line2: string;
  address1_line3: string;
  address1_postalcode: string;
  _rs_coloniaid_value: string;
  _rs_municipioid_value: string;
  _rs_estadoid_value: string;
  rs_antiguedadciudad: string;
  rs_antiguedadvivienda: string;
  _rs_tipovivienda_value: string;
  rs_montorenta: number;
  _rs_sucursalprospectoid_value: string;
  rs_horariocontacto: number;
  rs_estadocivil: number;
  rs_dependienteseconomicos1: number;
  rs_conyugeesclientelibertad: boolean;
  _rs_conyugeid_value: string;
  // Empleo
  _rs_profesionid_value: string;
  rs_nombreempresa: string;
  rs_nss: string;
  rs_antiguedadempresa: string;
  rs_ingresosfijos: number;
  rs_ingresosvariables: number;
  rs_fechabaja: string;
  rs_fechaingreso: string;
  rs_estadoempleado: number;
  rs_salariobasecotizacion: number;
  rs_nombrepatron: string;
  rs_continuarmismoingreso?: number;
  _rs_actividadbanxicoid_value: string;
  _rs_actividadeconomicaid_value: string;
  _rs_ocupacionid_value: string;
  _rs_puestoid_value: string;
  _rs_sectoreconomicoid_value: string;
  rs_instrumentomonetariomanejacuenta: number;
  // IMSS
  rs_edad: number;
  _rs_paisnacimiento_value: string;
  rs_tipoclienteimss: number;
  _rs_tipoproductoimssid_value: string;
  rs_montorequerido: number;
  rs_montototalapagar: number;
  rs_montototalinteres: number;
  rs_montototaliva: number;
  rs_capacidadpago: number;
  rs_descuentomensual: number;
  rs_pagofijo: number;
  rs_plazos: number;
  rs_catsiniva: number;
  rs_fechavencimiento: string;
  rs_fechaprimerdescuento: string;
  _rs_bancoid_value: string;
  rs_cuentaclave: string;
  // rs_referenciacredito: string;
  _rs_tipoconvenioid_value: string;
  rs_cuentacapacidadpago: number;
  rs_plazoquincenal: number;
  rs_montomaximo: number;
  rs_tasa: number;
  rs_periodopago: number;
  rs_usuario: string;
  rs_contraseniaimss: string;
  rs_detonaconsultacliente: boolean;
  rs_tipocliente: number;
  rs_finalidaddelosrecursos: number;
  rs_lead_quote_prospectoid?: {
    _rs_productoid_value: string;
    rs_productoid: {
      productid: string;
      rs_aplicapreautorizado?: boolean;
    };
  };
}

interface IsOfferPreautorizadoOData {
  rs_productoid?: {
    rs_aplicapreautorizado?: boolean;
  };
}

interface OfertaODataResponse extends ODataBaseResponse {
  rs_tipopreautorizado?: number;
  rs_saldoremanente?: number;
  quoteid: string;
  name: string;
  montominimo: number;
  _rs_productoid_value: string;
  quotenumber: string;
  rs_monto: number;
  rs_plazopagos: number;
  rs_tasainteresanualordinariafija: number;
  rs_catsiniva: number;
  rs_pagofijo: number;
  rs_montosegurodeuda: number;
  rs_montoliberasistencia: number;
  rs_tipoliberasistencia: number;
  rs_plazoliberasistencia: number;
  rs_creditoexpress: boolean;
  _rs_prospectoid_value: string;
  rs_montoserviciopreautorizado: number;
  rs_saldovigente: number;
  rs_pprenovacion: string;
  rs_aplicaexpress2: number;
  rs_mejoroferta: number;
  rs_productotasaminima: boolean;
  rs_plazomensual: number;
  rs_clublibertad: boolean;
  rs_plazoclublibertad?: number;
  rs_montoclublibertad?: number;
  statecode: number;
}

interface LeadProfilingConyugeODataResponse extends ODataBaseResponse {
  rs_nombre: string;
  rs_segundonombre?: string;
  rs_apellidopaterno: string;
  rs_apellidomaterno?: string;
  rs_fechanacimiento: string;
  rs_genero: number;
  rs_nipenviado: string;
  rs_nacionalidad: number;
  _rs_lugarnacimientoid_value: string;
  rs_curp?: string;
  rs_rfc?: string;
  _rs_ocupacionid_value: string;
  _rs_regimenmatrimonial_value: string;
}

interface LeadOfferReferenciaODataResponse extends ODataBaseResponse {
  rs_nombre: string;
  rs_segundonombre?: string;
  rs_apellidopaterno: string;
  rs_apellidomaterno?: string;
  rs_parentesco: number;
  rs_telefonocelular: string;
  rs_telefonocasa?: string;
  rs_tiemporelacion: string;
}

interface LeadOfferBeneficiarioODataResponse extends ODataBaseResponse {
  rs_nombre: string;
  rs_segundonombre?: string;
  rs_apellidopaterno: string;
  rs_apellidomaterno?: string;
  rs_parentesco: number;
  rs_fechanacimiento: string;
  _rs_lugarnacimientoid_value: string;
  rs_telefono: string;
  rs_porcentajebeneficio: number;
  rs_codigopostal: string;
  rs_calle: string;
  rs_numeroexterior: string;
  rs_numerointerior: string;
  _rs_coloniaid_value: string;
  _rs_municipioid_value: string;
  rs_rfc: string;
  rs_tipobeneficiario: number;
  rs_beneficiarioid: string;
}

interface LeadOfferEmpleoODataResponse extends ODataBaseResponse {
  _rs_puestoid_value: string;
  rs_name: string;
  _rs_actividadeconomicaid_value: string;
  _rs_sectoreconomicoid_value: string;
  rs_periodicidadingresos: number;
  rs_telefono: string;
  rs_extension?: string;
  rs_codigopostal: string;
  rs_calle: string;
  rs_numeroexterior: string;
  rs_numerointerior: string;
  _rs_coloniaid_value: string;
  _rs_municipioid_value: string;
  _rs_entidadfederativaid_value: string;
  rs_empleoid: string;
}

interface ConyugeODataResponse extends ODataBaseResponse {
  rs_conyugeid: string;
}

interface ReferenciaODataResponse extends ODataBaseResponse {
  rs_referenciaid: string;
}

interface BeneficiarioODataResponse extends ODataBaseResponse {
  rs_beneficiarioid: string;
}

interface EmpleoODataResponse extends ODataBaseResponse {
  rs_empleoid: string;
}

interface AnnotationODataResponse extends ODataBaseResponse {
  annotationid: string;
}

interface LeadPreauthorizedODataResponse extends ODataBaseResponse {
  leadid: string;
  rs_folio: string;
}

interface AppointmentODataResponse extends ODataBaseResponse {
  appointmentid: string;
}

interface SystemUserODataResponse extends ODataBaseResponse {
  systemuserid: string;
}

interface DesitionalMotorODataResponse {
  rs_registromotordecisionalid: {
    rs_mensajemotor: string;
    rs_resultadomotor: number;
    rs_ofertaminima: boolean;
    rs_motordecisionalid: string;
  };
}

interface DesitionalMotorErrorODataResponse {
  rs_registromotordecisionalid: {
    rs_resultadomotor: number;
    rs_motordecisionalid: string;
    _rs_mensajeerrorburoid_value: string;
    rs_mensajeerrorburoid: {
      rs_name: string;
    };
  };
}

interface MotorOfferODataResponse {
  rs_ofertaelegida: boolean;
  rs_ofertagenerada: boolean;
  rs_registromotordecisionalid: {
    rs_motordecisionalid: string;
    rs_montosolicitado: number;
    rs_mopactual: number;
    rs_mophistorico: number;
    statuscode: number;
    rs_dictamenfinal6133: string;
    rs_dictamenfinal6132: string;
    rs_ofertaminima: boolean;
  };
}

interface OfferExceededGuarantyRequest {
  quoteid: string;
  amount: number;
}

interface ScheduleInvestigation {
  rs_deseaagregarcomentariovisitainvestigacion: boolean;
  rs_horainiciovisitainvestigacion?: number;
  rs_horafinvisitainvestigacion?: number;
  rs_comentariosvisitainvestigacion?: string;
}

interface LeadUserODataResponse extends ODataBaseResponse {
  mobilephone: string;
  rs_folio: string;
  rs_sucursalprospectoid: {
    _rs_gerentesucursalid_value: string;
  };
}

interface ProductDataResponse {
  productid: string;
  name: string;
  rs_montomaximocreditoexpress: number;
  rs_montominimo: number;
  rs_montomaximo: number;
  rs_montoplazo: number;
  rs_montomaximoexpress: number;
  rs_aplicaclublibertad: boolean;
  rs_tramitedigital?: boolean;
  rs_montomaximoconaval: number;
  productnumber: string;
}

interface LeadDataODataResponse {
  rs_buroautenticado: number;
  rs_tipoproyecto: number;
}

interface LeadOfferDataResponse {
  _rs_empleoid_value: string | undefined;
  rs_parentescocliente: boolean;
  rs_parentesco1: number;
  rs_nombre1: string;
  rs_parentescoconsejo: boolean;
  rs_parentesco2: number;
  rs_nombre2: string;
  rs_formaparteconsejo: boolean;
  rs_cargo1: string;
  rs_poseeacciones: boolean;
  rs_eepecificarporcentaje: number;
  rs_accionespersonamoral: boolean;
  rs_denominacionsocial1: string;
  rs_consejoclienteprospecto: boolean;
  rs_denominacionsocial2: string;
  rs_nombreintegranteconsejo: string;
  rs_cargo2: string;
  rs_numclientereferido: string;
  rs_regimenpfopfae: boolean;
  rs_clienteactuacuentapropia: boolean;
  rs_dedondeprovienenlosrecursos_list: number;
  rs_procedenciarecursoscuenta_list: number;
  rs_importeesperamanejarmes_list: number;
  rs_montodepositos_list: number;
  rs_montoretiros_list: number;
  rs_numerodepositos_list: number;
  rs_numeroretiros_list: number;
  rs_aceptapublicidad: boolean;
  decisionmaker: boolean;
  rs_destinorecursoscuenta: number;
  rs_instrumentomonetariomanejacuenta: number;
}

export interface EconomicActivityResponse {
  ocupacion: string;
  puesto: string;
  acteconomica: string;
  secteconomico: string;
  actbanxico: string;
}

interface EconActODataResponse {
  _rs_ocupacionid_value: string;
  _rs_actividadbanxicoid_value: string;
  _rs_puestoid_value: string;
  _rs_actividadeconomicaid_value: string;
  _rs_sectoreconomicoid_value: string;
}

interface TwilioResponse {
  code: number;
  validacion: boolean;
}

interface TwilioRespODataResponse {
  code: number;
  valid: boolean;
}

interface PhoneVerificationODataResponse {
  rs_intentosvalidacionnumcel: number;
  statuscode: number;
}

interface TipoDocumentoODataResponse {
  rs_name: string;
  rs_expedienteid: string;
  rs_tipodocumentoid: {
    rs_id: string;
    rs_name: string;
  };
}

interface ContactProfilingODataResponse extends ODataBaseResponse {
  familystatuscode: any;
  telephone2: any;
  _rs_municipioid_value: string;
  address1_line3: string;
  address1_line2: string;
  address1_postalcode: any;
  address1_line1: any;
  _rs_colonia_value: string;
  rs_instrumentomonetariomanejaracuentas?: number;
  rs_destinorecursoscuenta?: number;
  gendercode: any;
  _rs_estadoid_value: any;
  _rs_paisdenacimiento_value: any;
  contactid: string;
  birthdate: string;
  emailaddress1: string;
  firstname: string;
  lastname: string;
  middlename: string;
  mobilephone: string;
  rs_segundonombre: string;
  rs_numerocliente?: string;
  rs_rfc?: string;
  rs_curp?: string;
}

interface LogPLD {
  rs_response: string;
  rs_logserviciosid: string;
  rs_prospectoid: {
    leadid: string;
  };
  rs_confirmamensajepld: number;
  rs_stateendpoint: number;
}

class LeadService extends ApiService {
  public constructor(config?: AxiosRequestConfig) {
    super(config);

    this.find = this.find.bind(this);
    this.findLeadType = this.findLeadType.bind(this);
    this.findPLDMatch = this.findPLDMatch.bind(this);
    this.findByFolio = this.findByFolio.bind(this);
    this.findLeadByFolio = this.findLeadByFolio.bind(this);
    this.siteVerification = this.siteVerification.bind(this);
    this.sendSms = this.sendSms.bind(this);
    this.recoverFolio = this.recoverFolio.bind(this);
    this.findUnique = this.findUnique.bind(this);
    this.findConfirmation = this.findConfirmation.bind(this);
    this.saveConfirmation = this.saveConfirmation.bind(this);
    this.getLeadProfiling = this.getLeadProfiling.bind(this);
    this.checkOffers = this.checkOffers.bind(this);
    this.findOffers = this.findOffers.bind(this);
    this.findExistOffers = this.findExistOffers.bind(this);
    this.findOfferById = this.findOfferById.bind(this);
    this.getOfferPreautorizado = this.getOfferPreautorizado.bind(this);
    this.updateOfferByIdPart1 = this.updateOfferByIdPart1.bind(this);
    this.updateOfferByIdPart2 = this.updateOfferByIdPart2.bind(this);
    this.getSelectedOffer = this.getSelectedOffer.bind(this);
    this.setSelectedOffer = this.setSelectedOffer.bind(this);
    this.setNotSelectedOffers = this.setNotSelectedOffers.bind(this);
    this.setSelectedOfferOnLead = this.setSelectedOfferOnLead.bind(this);
    this.setSelectedOfferTradicionalOnLead = this.setSelectedOfferTradicionalOnLead.bind(this);
    this.getLeadOffer = this.getLeadOffer.bind(this);
    this.create = this.create.bind(this);
    this.updatePersonalData = this.updatePersonalData.bind(this);
    this.updateLivingPlaceData = this.updateLivingPlaceData.bind(this);
    this.createSpouse = this.createSpouse.bind(this);
    this.updateJobData = this.updateJobData.bind(this);
    this.getCreditBureauRetries = this.getCreditBureauRetries.bind(this);
    this.getCreditBureauAuth = this.getCreditBureauAuth.bind(this);
    this.updateCreditBureauAuthorization = this.updateCreditBureauAuthorization.bind(this);
    this.creditBureauAuthorized = this.creditBureauAuthorized.bind(this);
    this.updateReferredClient = this.updateReferredClient.bind(this);
    this.createReferences = this.createReferences.bind(this);
    this.createBeneficiaries = this.createBeneficiaries.bind(this);
    this.createJobDetails = this.createJobDetails.bind(this);
    this.getJobByOpportunity = this.getJobByOpportunity.bind(this);
    this.updateLibertadRelationData = this.updateLibertadRelationData.bind(this);
    this.createAnnotation = this.createAnnotation.bind(this);
    this.triggerCreditRequest = this.triggerCreditRequest.bind(this);
    this.validateProofIdFront = this.validateProofIdFront.bind(this);
    // this.validateProofAddress = this.validateProofAddress.bind(this);
    this.getCreditRequestPdf = this.getCreditRequestPdf.bind(this);
    this.triggerCreditRejected = this.triggerCreditRejected.bind(this);
    this.triggerCreditEnd = this.triggerCreditEnd.bind(this);
    this.triggerRechazoOferta = this.triggerRechazoOferta.bind(this);
    this.disqualifyLead = this.disqualifyLead.bind(this);
    this.updateVerificatorCode = this.updateVerificatorCode.bind(this);
    this.updateLibertadAfilacionData = this.updateLibertadAfilacionData.bind(this);
    this.updateVirtualCurrency = this.updateVirtualCurrency.bind(this);
    this.getBeneficiaries = this.getBeneficiaries.bind(this);
    this.updateBeneficiaries = this.updateBeneficiaries.bind(this);
    this.updateJobDetails = this.updateJobDetails.bind(this);
    this.createPreauthorizedClient = this.createPreauthorizedClient.bind(this);
    this.createAppoinment = this.createAppoinment.bind(this);
    //this.getPhone = this.getPhone.bind(this);
    this.getUserId = this.getUserId.bind(this);
    //this.changeOwner = this.changeOwner.bind(this);
    this.info = this.info.bind(this);
    this.updateInfo = this.updateInfo.bind(this);
    this.updateLead = this.updateLead.bind(this);
    this.updateExistingLeadImss = this.updateExistingLeadImss.bind(this);
    this.sendSmsCustom = this.sendSmsCustom.bind(this);
    this.validateMop99 = this.validateMop99.bind(this);
    this.updateCustomerInquiry = this.updateCustomerInquiry.bind(this);
    this.getMotorResult = this.getMotorResult.bind(this);
    this.getRejectMessageMotor = this.getRejectMessageMotor.bind(this);
    this.getAmountClubLibertad = this.getAmountClubLibertad.bind(this);
    this.createScheduleNuevoDigital = this.createScheduleNuevoDigital.bind(this);
  }

  /**
   * Find the Lead by its Id
   *
   * @param {string} id
   * @returns {Promise<LeadResponse>}
   * @memberof LeadService
   */
  public async find(id: string): Promise<LeadResponse> {
    const res = await this.get<LeadResponse, AxiosResponse<LeadHeadODataResponse>>(
      `d365api/v1/leads(${id})?$select=leadid,rs_folio,firstname,middlename,rs_segundonombre,lastname` +
        ",rs_fechanacimiento,rs_tipocliente,rs_detonaflowrechazooferta,rs_numcredito,rs_origenprospecto" +
        ",rs_buroautenticado,rs_bcautenticado,rs_nipenviado,rs_codigoverificador,rs_edad,rs_validarmediocontacto" +
        ",_rs_tipoconvenioid_value,_rs_finalidadid_value,rs_tipoproyecto,_rs_sucursalprospectoid_value" +
        ",rs_periodopago,statecode,rs_matricula,_rs_estadodelegacionid_value,rs_montorequerido,rs_plazoquincenal" +
        ",rs_catsiniva,_rs_comprobanteingresosid_value,rs_pagofijo,_rs_tipoingreso_value,rs_finalidaddelosrecursos" +
        ",rs_afiliacionclublibertad,rs_tipofolio,_rs_ocupacionid_value,rs_instrumentomonetariomanejacuenta" +
        ",emailaddress1,mobilephone,rs_coincidenciapld,_rs_sujetocreditoid_value,_rs_tipotramiteid_value,rs_montoseguro" +
        ",statuscode",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return {
      id: res.data.leadid,
      number: res.data.rs_folio,
      firstName: res.data.firstname,
      nip: res.data.rs_nipenviado,
      codigoverificador: res.data.rs_nipenviado,
      middleName: res.data.rs_segundonombre,
      lastName: res.data.middlename,
      mothersLastName: res.data.lastname,
      birthDate: res.data.rs_fechanacimiento,
      tipoCliente: res.data.rs_tipocliente,
      numCredito: res.data.rs_numcredito,
      origenProspecto: res.data.rs_origenprospecto,
      buroAutenticado: res.data.rs_buroautenticado,
      bcAutenticado: res.data.rs_bcautenticado ? res.data.rs_bcautenticado : false,
      age: res.data.rs_edad,
      contactMean: res.data.rs_validarmediocontacto,
      agreementTypeId: res.data._rs_tipoconvenioid_value,
      purposeId: res.data._rs_finalidadid_value,
      proyectType: res.data.rs_tipoproyecto,
      branchId: res.data._rs_sucursalprospectoid_value,
      paymentPeriod: res.data.rs_periodopago,
      statecode: res.data.statecode,
      enrollment: res.data.rs_matricula,
      delegationState: res.data._rs_estadodelegacionid_value,
      requestedAmount: res.data.rs_montorequerido,
      selectedPeriod: res.data.rs_plazoquincenal,
      fixedRecurrentPayment: res.data.rs_pagofijo,
      calculatedCat: res.data.rs_catsiniva,
      // incomeProofId: res.data._rs_comprobanteingresosid_value,
      email: res.data.emailaddress1,
      phone: res.data.mobilephone,
      incomeTypeId: res.data._rs_tipoingreso_value,
      purposeResources: res.data.rs_finalidaddelosrecursos,
      pldMatch: res.data.rs_coincidenciapld,
      afiliacion: res.data.rs_afiliacionclublibertad,
      rs_tipofolio: res.data.rs_tipofolio,
      occupationId: res.data._rs_ocupacionid_value,
      monetaryInstrument: res.data.rs_instrumentomonetariomanejacuenta,
      subjectCredit: res.data._rs_sujetocreditoid_value,
      procedureType: res.data._rs_tipotramiteid_value,
      debtInsurance: res.data.rs_montoseguro,
      statuscode: res.data.statuscode
    };
  }

  public async findLeadData(id: string): Promise<LeadDataResponse> {
    const res = await this.get<LeadDataResponse, AxiosResponse<LeadDataODataResponse>>(`d365api/v1/leads(${id})?$select=rs_buroautenticado,rs_tipoproyecto`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    return {
      buroAutenticado: res.data.rs_buroautenticado,
      proyectType: res.data.rs_tipoproyecto
    };
  }

  public async findLeadType(id: string): Promise<LeadTypeRespose> {
    const res = await this.get<LeadTypeRespose, AxiosResponse<LeadHeadODataResponse>>(`d365api/v1/leads(${id})?$select=rs_tipocliente,rs_tipoproyecto`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    return {
      tipoCliente: res.data.rs_tipocliente,
      proyectType: res.data.rs_tipoproyecto
    };
  }

  public async findLeadOffer(id: string): Promise<LeadOfferRespose> {
    const res = await this.get<LeadOfferRespose, AxiosResponse<LeadHeadODataResponse>>(`d365api/v1/leads(${id})?$select=rs_tipocliente,rs_tipoproyecto,rs_afiliacionclublibertad`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    return {
      tipoCliente: res.data.rs_tipocliente,
      proyectType: res.data.rs_tipoproyecto,
      afiliacion: res.data.rs_afiliacionclublibertad
    };
  }

  public async findPLDMatch(id: string): Promise<LeadPLDMatchResponse> {
    const res = await this.get<LeadPLDMatchResponse, AxiosResponse<LeadHeadODataResponse>>(`d365api/v1/leads(${id})?$select=rs_coincidenciapld`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    return {
      pldMatch: res.data.rs_coincidenciapld
    };
  }

  public updateInfo(info: ModalInfoPersonal): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${info.lead})`,
      {
        mobilephone: info.phone,
        emailaddress1: info.email
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public updateLead(request: LeadRequest, id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        "rs_finalidadid@odata.bind": `/rs_finalidads(${request.purposeId})`,
        // "rs_comprobanteingresosid@odata.bind": `/rs_tipodocumentos(${request.incomeProofId})`,
        // "ownerid@odata.bind": `/teams(${request.ownerId})`,
        rs_montorequerido: request.requestedAmount,
        rs_plazoquincenal: request.selectedPeriod,
        rs_pagofijo: request.fixedRecurrentPayment,
        rs_catsiniva: request.calculatedCat,
        rs_tipoproceso: 1,
        rs_tipocliente: 1,
        rs_origenprospecto: 3,
        "rs_tipoingreso@odata.bind": `/rs_tipodeingresos(${request.incomeTypeId})`,
        rs_finalidaddelosrecursos: request.purposeResources
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Updates a Lead with General data
   *
   * @param {string} id
   * @param {string} purposeId
   * @returns {Promise<unknown>}
   * @memberof ImssService
   */
  public updateExistingLeadImss(purposeId: string, id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        "rs_finalidadid@odata.bind": `/rs_finalidads(${purposeId})`,
        rs_tipoproyecto: 0, //IMSS
        rs_mostrartabdatospersonales: true
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async info(id: string): Promise<ModalInfoPersonal> {
    const res = await this.get<LeadResponse, AxiosResponse<LeadHeadODataResponse>>(
      // `d365api/v1/leads(${id})?$select=leadid,rs_folio,emailaddress1,mobilephone&$expand=rs_lead_quote_prospectoid($select=quoteid,_rs_productoid_value;$expand=rs_productoid($select=rs_aplicapreautorizado))`
      `d365api/v1/leads(${id})?$select=leadid,rs_folio,emailaddress1,mobilephone`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return {
      lead: res.data.leadid,
      email: res.data.emailaddress1,
      phone: res.data.mobilephone
      // isPreautorizado: res.data?.rs_lead_quote_prospectoid[0]?.rs_productoid?.rs_aplicapreautorizado
    };
  }

  /**
   * Find the Lead by its Folio
   *
   * @param {string} folio
   * @returns {(Promise<string | undefined>)}
   * @memberof LeadService
   */
  public async findByFolio(folio: string): Promise<string | undefined> {
    // FIXME: Should not send request 'as is' since it can be modified by a MITM, it should also be a POST method
    const res = await this.get<LeadResponse, AxiosResponse<ODataMultipleResponse<LeadHeadODataResponse[]>>>(
      `d365api/v1/leads?$select=leadid,rs_folio&$filter=rs_folio eq '${folio}' and statecode eq 0&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value[0]?.leadid ?? undefined;
  }

  /**
   * Find the Lead by its Folio
   *
   * @param {string} folio
   * @returns {(Promise<string | undefined>)}
   * @memberof LeadService
   */
  public async findLeadByFolio(folio: string): Promise<LeadSearchResponse | undefined> {
    // FIXME: Should not send request 'as is' since it can be modified by a MITM, it should also be a POST method
    const res = await this.get<LeadResponse, AxiosResponse<ODataMultipleResponse<LeadHeadODataResponse[]>>>(
      `d365api/v1/leads?$select=leadid,rs_folio,_rs_finalidadid_value,statecode,rs_tipoproyecto,rs_tipocliente&$filter=rs_folio eq '${folio}'&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res?.data?.value != null && res?.data?.value?.length > 0) {
      const lead = res.data.value[0];
      return {
        id: lead.leadid,
        // purposeId: lead._rs_finalidadid_value,
        state: lead.statecode,
        projectType: lead.rs_tipoproyecto,
        clientType: lead.rs_tipocliente
      };
    } else {
      return undefined;
    }
  }

  /**
   * Gets the Site Verification
   * TODO: Validar
   * @param {string} token
   * @returns {(Promise<string | undefined>)}
   * @memberof LeadService
   */
  public async siteVerification(token: string): Promise<{ success: boolean; score: number; action: string }> {
    // FIXME: Replace and join request on backend endpoint, validation should be server side.
    const tokenValidation = await this.post<{ success: boolean; score: number; action: string }, AxiosResponse<{ success: boolean; score: number; action: string }>>(
      `captcha/v1/siteverify?response=${token}`,
      undefined,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return tokenValidation.data;
  }

  /**
   * Sends an SMS to the specified Lead ID.
   *
   * @param {string} leadId
   * @param {string} nipField
   * @returns {(Promise<string | undefined>)}
   * @memberof LeadService
   */
  public async sendSms(leadId: string, nipField: string): Promise<void> {
    // FIXME: This shouldn't be done like this but as I mentioned several times, there's no backend for the frontend ¯\(°_o)/¯
    const res = await this.get<
      { mobilephone: string; rs_nipenviado: string; rs_nipautorizacionbc: string; rs_nipautorizacionsc: string },
      AxiosResponse<{ mobilephone: string; rs_nipenviado: string; rs_nipautorizacionbc: string; rs_nipautorizacionsc: string }>
    >(`d365api/v1/leads(${leadId})?$select=leadid,mobilephone,rs_nipenviado,rs_nipautorizacionbc,rs_nipautorizacionsc`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    let nip = "";
    let tag = "";
    if (nipField === "nipautorizacionbc") {
      nip = res.data.rs_nipautorizacionbc;
      tag = "bc";
    } else if (nipField === "nipautorizacionsc") {
      nip = res.data.rs_nipautorizacionsc;
      tag = "sc";
    } else if (nipField === "nipenviado") {
      nip = res.data.rs_nipenviado;
      tag = "new";
    }

    await this.post<unknown, unknown, AxiosResponse<unknown>>(
      "v1",
      {
        message: `Tu NIP de verificación es: ${nip}`,
        msisdns: [`52${res.data.mobilephone}`],
        tag: tag
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  /**
   * Recover the Folio using the Mobile Phone.
   * TODO: Validar
   * @param {string} mobile
   * @param {string} token
   * @param {string} action
   * @returns {(Promise<boolean>)}
   * @memberof LeadService
   */
  public async recoverFolio(mobile: string, token: string, action: string): Promise<boolean> {
    // FIXME: Replace and join request on backend endpoint, validation should be server side.

    //TODO: Se retira el recatch para pruebas
    // const tokenValidation = await this.post<{ success: boolean; score: number; action: string }, AxiosResponse<{ success: boolean; score: number; action: string }>>(
    //   `captcha/v1/siteverify?response=${token}`,
    //   undefined,
    //   {
    //     headers: {
    //       "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
    //     }
    //   }
    // );
    // if (!tokenValidation.data.success) return false;
    // if (tokenValidation.data.action !== action) return false;
    // if (tokenValidation.data.score <= 0.3) return false;

    // FIXME: Should not send request 'as is' since it can be modified by a MITM, it should also be a POST method
    const res = await this.get<LeadResponse, AxiosResponse<ODataMultipleResponse<LeadHeadODataResponse[]>>>(
      `d365api/v1/leads?$select=leadid,rs_folio&$filter=mobilephone eq '${mobile}' and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    const result = res.data.value[0]?.leadid !== undefined;
    if (result) {
      const folio = res.data.value[0]?.rs_folio;
      await this.post<unknown, unknown, AxiosResponse<unknown>>(
        "v1",
        {
          message: `Tu folio de solicitud de credito es: ${folio}`,
          msisdns: [`52${mobile}`],
          tag: `portal-folio-${folio}`
        },
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );
    }
    return result;
  }

  /**
   * Find the Lead by Full Name, Email and Mobile Phone.
   *
   * @param {Readonly<LeadRequest>} request
   * @returns {(Promise<boolean>)}
   * @memberof LeadService
   */
  public async findUnique(request: Readonly<LeadRequest>): Promise<boolean> {
    // FIXME: Should not send request 'as is' since it can be modified by a MITM, it should also be a POST method
    const res = await this.get<LeadResponse, AxiosResponse<ODataMultipleResponse<LeadHeadODataResponse[]>>>(
      `d365api/v1/leads?$select=leadid,rs_folio&$filter=firstname eq '${request.firstName}' and middlename eq '${request.lastName}' and lastname eq '${request.mothersLastName}' and emailaddress1 eq '${request.email}' and mobilephone eq '${request.mobile}' and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value[0]?.leadid !== undefined;
  }

  /**
   * Find if the Lead matches the Confirmation Code (NIP)
   *
   * @param {string} id
   * @param {string} nip
   * @param {string} nipField
   * @returns {Promise<boolean>}
   * @memberof LeadService
   */
  public async findConfirmation(id: string, nip: string, nipField: string): Promise<boolean> {
    // FIXME: Should not send request 'as is' since it can be modified and nip verification excluded, it should also be a POST method
    const res = await this.get<LeadResponse, AxiosResponse<ODataMultipleResponse<LeadHeadODataResponse[]>>>(
      `d365api/v1/leads?$select=leadid,rs_folio&$filter=rs_${nipField} eq '${nip}' and leadid eq ('${id}')`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value.length == 1 && res.data.value[0].leadid !== undefined && res.data.value[0].rs_folio !== undefined;
  }

  /**
   * Saves the Confirmation Code (NIP)
   *
   * @param {string} id
   * @param {string} nip
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async saveConfirmation(id: string, nip: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_codigoverificador: nip
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Gets the Lead Profiling data by its Id
   *
   * @param {string} id
   * @returns {Promise<Partial<LeadProfilingResponse>>}
   * @memberof LeadService
   */
  public async getLeadProfiling(id: string): Promise<Partial<LeadProfilingResponse>> {
    const res = await this.get<Partial<LeadProfilingResponse>, AxiosResponse<LeadProfilingODataResponse>>(
      `d365api/v1/leads(${id})?$select=leadid,rs_folio,firstname,rs_segundonombre,middlename,lastname,emailaddress1` +
        ",rs_fechanacimiento,rs_genero,_rs_paisnacimiento_value,_rs_lugarnacimientoid_value,rs_nacionalidad,mobilephone" +
        ",telephone2,_rs_nivelestudios_value,rs_curp,rs_rfc,rs_nipenviado,rs_edad,address1_line1,address1_line2" +
        ",address1_line3,address1_postalcode,_rs_coloniaid_value,_rs_municipioid_value,_rs_estadoid_value" +
        ",rs_antiguedadciudad,rs_antiguedadvivienda,_rs_tipovivienda_value,rs_montorenta,_rs_sucursalprospectoid_value" +
        ",rs_horariocontacto,rs_estadocivil,rs_dependienteseconomicos1,rs_conyugeesclientelibertad,_rs_conyugeid_value" +
        ",_rs_profesionid_value,_rs_ocupacionid_value,rs_nombreempresa,rs_nss,rs_antiguedadempresa,rs_ingresosfijos" +
        ",rs_ingresosvariables,rs_tipoclienteimss,_rs_tipoproductoimssid_value,_rs_tipoconvenioid_value,rs_montorequerido" +
        ",rs_montototalapagar,rs_montototalinteres,rs_montototaliva,rs_descuentomensual,rs_capacidadpago,rs_fechavencimiento" +
        ",rs_fechaprimerdescuento,rs_cuentacapacidadpago,rs_pagofijo,rs_plazos,rs_catsiniva,_rs_bancoid_value,rs_cuentaclave" +
        ",rs_plazoquincenal,rs_montomaximo,rs_tasa,rs_periodopago,rs_usuario,rs_contraseniaimss,_rs_sujetocreditoid_value,_rs_tipotramiteid_value" +
        //
        ",rs_nombrepatron,rs_continuarmismoingreso,rs_salariobasecotizacion,rs_estadoempleado,rs_fechaingreso,rs_fechabaja" +
        ",_rs_actividadbanxicoid_value,_rs_actividadeconomicaid_value,_rs_ocupacionid_value,_rs_puestoid_value,_rs_sectoreconomicoid_value,rs_instrumentomonetariomanejacuenta" +
        ",rs_detonaconsultacliente,rs_tipocliente,rs_finalidaddelosrecursos&" +
        "$expand=rs_lead_quote_prospectoid($select=name,quoteid,rs_monto,_rs_productoid_value;$expand=rs_productoid($select=rs_aplicapreautorizado))",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let spouse: Partial<LeadProfilingSpouseResponse> | undefined;
    if (res.data._rs_conyugeid_value) {
      spouse = {};
      const rs = await this.get<Partial<LeadProfilingSpouseResponse>, AxiosResponse<LeadProfilingConyugeODataResponse>>(`d365api/v1/rs_conyuges(${res.data._rs_conyugeid_value})`, {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      });
      spouse.firstName = rs.data.rs_nombre;
      spouse.middleName = rs.data.rs_segundonombre;
      spouse.lastName = rs.data.rs_apellidopaterno;
      spouse.mothersLastName = rs.data.rs_apellidomaterno;
      spouse.birthDate = rs.data.rs_fechanacimiento;
      spouse.genre = rs.data.rs_genero;
      spouse.nip = res.data.rs_nipenviado;
      spouse.birthPlaceId = rs.data._rs_lugarnacimientoid_value;
      spouse.nationality = rs.data.rs_nacionalidad;
      spouse.occupationId = rs.data._rs_ocupacionid_value;
      spouse.matrimonialRegimeId = rs.data._rs_regimenmatrimonial_value;
      spouse.curp = rs.data.rs_curp;
      spouse.rfc = rs.data.rs_rfc;
    }

    return {
      id: res.data.leadid,
      number: res.data.rs_folio,
      firstName: res.data.firstname,
      middleName: res.data.rs_segundonombre,
      lastName: res.data.middlename,
      mothersLastName: res.data.lastname,
      birthDate: res.data.rs_fechanacimiento,
      email: res.data.emailaddress1,
      movil: res.data.mobilephone,
      genre: res.data.rs_genero,
      birthCountryId: res.data._rs_paisnacimiento_value,
      birthPlaceId: res.data._rs_lugarnacimientoid_value,
      nationality: res.data.rs_nacionalidad,
      phone: res.data.telephone2,
      educationLevelId: res.data._rs_nivelestudios_value,
      curp: res.data.rs_curp,
      rfc: res.data.rs_rfc,
      nip: res.data.rs_nipenviado,
      age: res.data.rs_edad,
      subjectCredit: res.data._rs_sujetocreditoid_value,
      procedureType: res.data._rs_tipotramiteid_value,
      // Living
      street: res.data.address1_line1,
      extNumber: res.data.address1_line2,
      intNumber: res.data.address1_line3,
      postalCode: res.data.address1_postalcode,
      street2Id: res.data._rs_coloniaid_value,
      cityId: res.data._rs_municipioid_value,
      stateId: res.data._rs_estadoid_value,
      yearsAtCity: res.data.rs_antiguedadciudad,
      yearsAtHome: res.data.rs_antiguedadvivienda,
      propertyKindId: res.data._rs_tipovivienda_value,
      rentAmount: res.data.rs_montorenta,
      branchId: res.data._rs_sucursalprospectoid_value,
      contactSchedule: res.data.rs_horariocontacto,
      maritalStatus: res.data.rs_estadocivil,
      economicDependents: res.data.rs_dependienteseconomicos1,
      spouseLibertad: res.data.rs_conyugeesclientelibertad == true ? 2 : res.data.rs_conyugeesclientelibertad == false ? 1 : 0,
      spouseId: res.data._rs_conyugeid_value,
      spouse: spouse as LeadProfilingSpouseResponse,
      // Job
      professionId: res.data._rs_profesionid_value,
      occupationId: res.data._rs_ocupacionid_value,
      companyName: res.data.rs_nombreempresa,
      ssn: res.data.rs_nss,
      yearsAtWork: res.data.rs_antiguedadempresa,
      fixedIncome: res.data.rs_ingresosfijos,
      variableIncome: res.data.rs_ingresosvariables,
      continueSameIncome: res.data.rs_continuarmismoingreso,
      patternName: res.data.rs_nombrepatron,
      salaryQuote: res.data.rs_salariobasecotizacion,
      employedStatus: res.data.rs_estadoempleado,
      admissionDate: res.data.rs_fechaingreso,
      lowDate: res.data.rs_fechabaja,

      banxicoActivity: res.data._rs_actividadbanxicoid_value,
      economicActivityId: res.data._rs_actividadeconomicaid_value,
      economicSectorId: res.data._rs_sectoreconomicoid_value,
      positionId: res.data._rs_puestoid_value,
      instrumentoMonetario: res.data.rs_instrumentomonetariomanejacuenta,

      // IMSS
      clientTypeImss: res.data.rs_tipoclienteimss,
      productTypeId: res.data._rs_tipoproductoimssid_value,
      agreementTypeId: res.data._rs_tipoconvenioid_value,
      requiredAmount: res.data.rs_montorequerido,
      totalAmount: res.data.rs_montototalapagar,
      interestAmount: res.data.rs_montototalinteres,
      ivaAmount: res.data.rs_montototaliva,
      monthlyDiscount: res.data.rs_descuentomensual,
      paymentCapacity: res.data.rs_capacidadpago,
      dueDate: res.data.rs_fechavencimiento,
      firstDiscountDate: res.data.rs_fechaprimerdescuento,
      abilityPay: res.data.rs_cuentacapacidadpago,
      fixedPayment: res.data.rs_pagofijo,
      monthlyTerm: res.data.rs_plazos,
      catWithoutIva: res.data.rs_catsiniva,
      bankId: res.data._rs_bancoid_value,
      keyAccount: res.data.rs_cuentaclave,
      // creditReference: res.data.rs_referenciacredito,
      biweeklyTerm: res.data.rs_plazoquincenal,
      maximumAmount: res.data.rs_montomaximo,
      monthlyRate: res.data.rs_tasa,
      paymentPeriodImss: res.data.rs_periodopago,
      userImssPortal: res.data.rs_usuario,
      passwordImssPortal: res.data.rs_contraseniaimss,
      customerSearch: res.data.rs_detonaconsultacliente,
      clientType: res.data.rs_tipocliente,
      purposeResources: res.data.rs_finalidaddelosrecursos,
      isPreautorizado: res.data?.rs_lead_quote_prospectoid[0]?.rs_productoid?.rs_aplicapreautorizado
    };
  }

  /**
   * Gets the Lead Profiling data by its Id
   *
   * @param {string} id
   * @returns {Promise<Partial<LeadProfilingResponse>>}
   * @memberof LeadService
   */
  public async getProfilingImssData(id: string): Promise<Partial<LeadProfilingResponse>> {
    const res = await this.get<Partial<LeadProfilingResponse>, AxiosResponse<LeadProfilingODataResponse>>(
      `d365api/v1/leads(${id})?$select=leadid,rs_nss,rs_ingresosfijos` + ",rs_nombrepatron,rs_continuarmismoingreso,rs_salariobasecotizacion,rs_estadoempleado,rs_fechaingreso,rs_fechabaja",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return {
      id: res.data.leadid,
      number: res.data.rs_folio,
      firstName: res.data.firstname,
      middleName: res.data.rs_segundonombre,
      lastName: res.data.middlename,
      mothersLastName: res.data.lastname,
      birthDate: res.data.rs_fechanacimiento,
      genre: res.data.rs_genero,
      birthCountryId: res.data._rs_paisnacimiento_value,
      birthPlaceId: res.data._rs_lugarnacimientoid_value,
      nationality: res.data.rs_nacionalidad,
      phone: res.data.telephone2,
      educationLevelId: res.data._rs_nivelestudios_value,
      curp: res.data.rs_curp,
      rfc: res.data.rs_rfc,
      nip: res.data.rs_nipenviado,
      // Living
      street: res.data.address1_line1,
      extNumber: res.data.address1_line2,
      intNumber: res.data.address1_line3,
      postalCode: res.data.address1_postalcode,
      street2Id: res.data._rs_coloniaid_value,
      cityId: res.data._rs_municipioid_value,
      stateId: res.data._rs_estadoid_value,
      yearsAtCity: res.data.rs_antiguedadciudad,
      yearsAtHome: res.data.rs_antiguedadvivienda,
      propertyKindId: res.data._rs_tipovivienda_value,
      rentAmount: res.data.rs_montorenta,
      branchId: res.data._rs_sucursalprospectoid_value,
      contactSchedule: res.data.rs_horariocontacto,
      maritalStatus: res.data.rs_estadocivil,
      economicDependents: res.data.rs_dependienteseconomicos1,
      spouseId: res.data._rs_conyugeid_value,
      // Job
      professionId: res.data._rs_profesionid_value,
      occupationId: res.data._rs_ocupacionid_value,
      companyName: res.data.rs_nombreempresa,
      ssn: res.data.rs_nss,
      yearsAtWork: res.data.rs_antiguedadempresa,
      fixedIncome: res.data.rs_ingresosfijos,
      variableIncome: res.data.rs_ingresosvariables,
      continueSameIncome: res.data.rs_continuarmismoingreso,
      patternName: res.data.rs_nombrepatron,
      salaryQuote: res.data.rs_salariobasecotizacion,
      employedStatus: res.data.rs_estadoempleado,
      admissionDate: res.data.rs_fechaingreso,
      lowDate: res.data.rs_fechabaja
    };
  }

  /**
   * Find status result motor from the specified Lead
   *
   * @param {string} id
   * @returns {Promise<OfferResponse[]>}
   * @memberof LeadService
   */
  public async getMotorProfilingData(id: string): Promise<MotorProfilingDataResponse> {
    const resMotor = await this.get<MotorOfferODataResponse, AxiosResponse<MotorOfferODataResponse>>(
      `d365api/v1/leads(${id})?$select=leadid,rs_ofertaelegida&$expand=rs_registromotordecisionalid($select=statuscode,rs_motordecisionalid)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (resMotor != null && resMotor.data != null && resMotor.data?.rs_registromotordecisionalid != null) {
      return {
        status: resMotor.data?.rs_registromotordecisionalid?.statuscode,
        ofertaElegida: resMotor.data?.rs_ofertaelegida
      };
    }

    return null;
  }

  public async checkOffers(id: string): Promise<OfferAvailableResponse> {
    const res = await this.get<
      { leadid: string; rs_ofertagenerada: boolean; rs_resultadomotor: number | null },
      AxiosResponse<{ leadid: string; rs_ofertagenerada: boolean; rs_resultadomotor: number | null }>
    >(`d365api/v1/leads(${id})?$select=leadid,rs_ofertagenerada,rs_resultadomotor`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    // rs_resultadomotor values: ACEPTADO (1), RECHAZADO (2), null
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return { available: res!.data.rs_ofertagenerada, accepted: res!.data.rs_resultadomotor };
  }

  /**
   * Find the Offers from the specified Lead
   *
   * @param {string} id
   * @param {MotorOfferDataResponse} resMotor
   * @returns {Promise<OfferResponse[]>}
   * @memberof LeadService
   */
  public async findOffers(id: string, resMotor: MotorOfferDataResponse, ent: string): Promise<OfferResponse[]> {
    const res = await this.get<OfertaODataResponse, AxiosResponse<ODataMultipleResponse<OfertaODataResponse[]>>>(
      `d365api/v1/quotes?$filter=${ent} eq ('${id}') and statecode eq 0&$orderby=name asc` +
        `&$select=quoteid,quotenumber,_rs_productoid_value,${ent},rs_monto,rs_plazopagos` +
        ",rs_tasainteresanualordinariafija,rs_catsiniva,rs_pagofijo,rs_montosegurodeuda,rs_montoliberasistencia" +
        ",rs_tipoliberasistencia,rs_plazoliberasistencia,rs_pprenovacion,rs_montoserviciopreautorizado,rs_saldovigente" +
        ",rs_aplicaexpress2,rs_mejoroferta,rs_productotasaminima,rs_plazomensual,rs_creditoexpress" +
        ",rs_clublibertad,rs_plazoclublibertad,rs_montoclublibertad,rs_saldoremanente,rs_tipopreautorizado",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    const offers: OfferResponse[] = [];
    res.data.value.forEach(async (o) => {
      const prodRes = await this.get<ProductDataResponse, AxiosResponse<ProductDataResponse>>(
        `d365api/v1/products(${o._rs_productoid_value})?$select=name,rs_montominimo,rs_montomaximo,rs_montoplazo` +
          ",rs_montomaximocreditoexpress,rs_montomaximoexpress,rs_aplicaclublibertad" +
          ",rs_tramitedigital,rs_montomaximoconaval,productnumber",
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );

      offers.push({
        id: o.quoteid,
        offerId: o.quoteid,
        name: prodRes.data.name,
        productNumber: prodRes.data.productnumber,
        montominimo: prodRes.data.rs_montominimo,
        montomaximo: prodRes.data.rs_montomaximo,
        montoplazo: prodRes.data.rs_montoplazo,
        code: o.quotenumber,
        leadId: o._rs_prospectoid_value,
        productId: o._rs_productoid_value,
        amount: o.rs_monto,
        term: o.rs_plazopagos,
        ordinaryAnnualRate: o.rs_tasainteresanualordinariafija,
        cat: o.rs_catsiniva,
        payment: o.rs_pagofijo,
        debtInsuranceAmount: o.rs_montosegurodeuda,
        liberasistenciaAmount: o.rs_montoliberasistencia,
        liberasistenciaKind: o.rs_tipoliberasistencia,
        liberasistenciaTerm: o.rs_plazoliberasistencia,
        express: false,
        expressMaxAmount: 0,
        pprenovacion: o.rs_pprenovacion,
        montoserviciopreautorizado: o.rs_montoserviciopreautorizado,
        saldovigente: o.rs_saldovigente,
        aplicaExpress: o.rs_aplicaexpress2,
        mejorOferta: o.rs_mejoroferta == null ? 0 : o.rs_mejoroferta,
        productMinimumRate: o.rs_productotasaminima == null ? false : o.rs_productotasaminima,
        monthlyTerm: o.rs_plazomensual,
        clubLibertadValue: o.rs_clublibertad,
        termClubLibertad: o.rs_plazoclublibertad,
        amountClubLibertad: o.rs_montoclublibertad,
        aplicaClubLibertad: prodRes.data?.rs_aplicaclublibertad,
        tramiteDigital: prodRes.data?.rs_tramitedigital ? prodRes.data.rs_tramitedigital : false,
        maxAmountWithAval: prodRes.data?.rs_montomaximoconaval,
        amountRequestMotor: resMotor?.amountRequest,
        actualMop: resMotor?.actualMop,
        historicalMop: resMotor?.historicalMop,
        remainingBalance: o?.rs_saldoremanente,
        typePreautorizade: o?.rs_tipopreautorizado
      });

      if (offers.length === 1 && o.rs_creditoexpress) {
        const express = offers[0];

        let monto = 0;
        if (express.aplicaExpress === 0) monto = prodRes.data.rs_montomaximocreditoexpress;
        else monto = prodRes.data.rs_montomaximoexpress;

        offers.push({
          id: `EXPRESS-${express.id}`,
          offerId: express.id,
          name: "EXPRESS",
          productNumber: express.productNumber,
          montominimo: express.montominimo,
          montomaximo: express.montomaximo,
          montoplazo: express.montoplazo,
          code: "TRÁMITE RÁPIDO",
          leadId: express.leadId,
          productId: express.productId,
          amount: monto,
          term: express.term,
          ordinaryAnnualRate: express.ordinaryAnnualRate,
          cat: express.cat,
          payment: express.payment,
          debtInsuranceAmount: express.debtInsuranceAmount,
          liberasistenciaAmount: express.liberasistenciaAmount,
          liberasistenciaKind: express.liberasistenciaKind,
          liberasistenciaTerm: express.liberasistenciaTerm,
          express: true,
          expressMaxAmount: express.aplicaExpress == 0 ? prodRes.data.rs_montomaximocreditoexpress : prodRes.data.rs_montomaximoexpress, //prodRes.data.rs_montomaximocreditoexpress,
          pprenovacion: express.pprenovacion,
          montoserviciopreautorizado: express.montoserviciopreautorizado,
          saldovigente: express.saldovigente,
          aplicaExpress: express.aplicaExpress,
          mejorOferta: 0,
          productMinimumRate: express.productMinimumRate,
          monthlyTerm: express.monthlyTerm,
          clubLibertadValue: express.clubLibertadValue,
          termClubLibertad: express.termClubLibertad,
          amountClubLibertad: express.amountClubLibertad,
          aplicaClubLibertad: express.aplicaClubLibertad,
          maxAmountWithAval: express.maxAmountWithAval,
          amountRequestMotor: express.amountRequestMotor,
          actualMop: express.actualMop,
          historicalMop: express.historicalMop
        });
      }
    });

    return offers;
  }

  /**
   * Find cancel Offers from the specified Lead
   *
   * @param {string} id
   * @returns {Promise<OfferResponse[]>}
   * @memberof LeadService
   */
  public async findAllOffers(id: string): Promise<OfferResponse[]> {
    const res = await this.get<OfertaODataResponse, AxiosResponse<ODataMultipleResponse<OfertaODataResponse[]>>>(
      `d365api/v1/quotes?$filter=_rs_prospectoid_value eq ('${id}')&$orderby=name asc` + "&$select=quoteid,statecode",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    const offers: OfferResponse[] = [];
    res.data.value.forEach((o) => {
      offers.push({
        id: o.quoteid,
        offerId: o.quoteid,
        name: "",
        productNumber: "",
        montominimo: 0,
        montomaximo: 0,
        montoplazo: 0,
        code: o.quotenumber,
        leadId: o._rs_prospectoid_value,
        productId: o._rs_productoid_value,
        amount: o.rs_monto,
        term: o.rs_plazopagos,
        ordinaryAnnualRate: o.rs_tasainteresanualordinariafija,
        cat: o.rs_catsiniva,
        payment: o.rs_pagofijo,
        debtInsuranceAmount: o.rs_montosegurodeuda,
        liberasistenciaAmount: o.rs_montoliberasistencia,
        liberasistenciaKind: o.rs_tipoliberasistencia,
        liberasistenciaTerm: o.rs_plazoliberasistencia,
        express: false,
        expressMaxAmount: 0,
        pprenovacion: o.rs_pprenovacion,
        montoserviciopreautorizado: o.rs_montoserviciopreautorizado,
        saldovigente: o.rs_saldovigente,
        aplicaExpress: o.rs_aplicaexpress2,
        mejorOferta: o.rs_mejoroferta == null ? 0 : o.rs_mejoroferta,
        productMinimumRate: o.rs_productotasaminima == null ? false : o.rs_productotasaminima,
        monthlyTerm: o.rs_plazomensual,
        clubLibertadValue: o.rs_clublibertad,
        termClubLibertad: o.rs_plazoclublibertad,
        amountClubLibertad: o.rs_montoclublibertad,
        aplicaClubLibertad: false,
        state: o.statecode
      });
    });

    return offers;
  }

  /**
   * Find offer data by the result motor from the specified Lead
   *
   * @param {string} id
   * @returns {Promise<OfferResponse[]>}
   * @memberof LeadService
   */
  public async getMotorOfferData(id: string): Promise<MotorOfferDataResponse> {
    const resMotor = await this.get<MotorOfferODataResponse, AxiosResponse<MotorOfferODataResponse>>(
      `d365api/v1/leads(${id})?$select=leadid,rs_ofertagenerada,rs_ofertaelegida,&` +
        `$expand=rs_registromotordecisionalid($select=rs_montosolicitado,rs_mopactual,rs_mophistorico,statuscode,rs_motordecisionalid,rs_dictamenfinal6132,` +
        `rs_dictamenfinal6133,rs_ofertaminima)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (resMotor != null && resMotor.data != null && resMotor.data?.rs_registromotordecisionalid != null) {
      return {
        amountRequest: resMotor.data?.rs_registromotordecisionalid?.rs_montosolicitado,
        actualMop: resMotor.data?.rs_registromotordecisionalid?.rs_mopactual,
        historicalMop: resMotor.data?.rs_registromotordecisionalid?.rs_mophistorico,
        status: resMotor.data?.rs_registromotordecisionalid?.statuscode,
        rs_ofertaelegida: resMotor.data?.rs_ofertaelegida,
        rs_ofertagenerada: resMotor.data?.rs_ofertagenerada,
        rs_motordecisionalid: resMotor.data?.rs_registromotordecisionalid?.rs_motordecisionalid,
        dictamenFinal6132: resMotor.data?.rs_registromotordecisionalid.rs_dictamenfinal6132,
        dictamenFinal6133: resMotor.data?.rs_registromotordecisionalid.rs_dictamenfinal6133,
        ofertaMinima: resMotor.data?.rs_registromotordecisionalid.rs_ofertaminima
      };
    }

    return null;
  }

  /**
   * Find the Offers from the specified Lead
   *
   * @param {string} id
   * @returns {Promise<{ quoteid: string }[]>}
   * @memberof LeadService
   */
  public async findExistOffers(id: string): Promise<{ quoteid: string }[]> {
    const res = await this.get<{ quoteid: string }, AxiosResponse<ODataMultipleResponse<{ quoteid: string }[]>>>(
      `d365api/v1/quotes?$select=quoteid&$filter=_rs_prospectoid_value eq ('${id}') and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (res.data != undefined && res.data?.value != null) return res.data?.value;
    else return null;
  }

  /**
   * Find the Offer from the specified Offer Id
   *
   * @param {string} id
   * @returns {Promise<OfferResponse>}
   * @memberof LeadService
   */
  public async findOfferById(id: string): Promise<OfferResponse> {
    const res = await this.get<OfertaODataResponse, AxiosResponse<OfertaODataResponse>>(
      `d365api/v1/quotes(${id})?$select=quoteid,quotenumber,_rs_productoid_value,_rs_prospectoid_value,rs_monto,rs_plazopagos` +
        ",rs_tasainteresanualordinariafija,rs_catsiniva,rs_pagofijo,rs_montosegurodeuda,rs_montoliberasistencia" +
        ",rs_tipoliberasistencia,rs_plazoliberasistencia,rs_pprenovacion,rs_montoserviciopreautorizado,rs_saldovigente" +
        ",rs_aplicaexpress2,rs_mejoroferta,rs_productotasaminima,rs_plazomensual,rs_creditoexpress" +
        ",rs_clublibertad,rs_plazoclublibertad,rs_montoclublibertad",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const prodRes = await this.get<ProductDataResponse, AxiosResponse<ProductDataResponse>>(
      `d365api/v1/products(${res.data._rs_productoid_value})?$select=name,rs_montominimo,rs_montomaximo,rs_montoplazo` +
        ",rs_montomaximocreditoexpress,rs_montomaximoexpress,rs_aplicaclublibertad,productnumber",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return {
      id: res.data.quoteid,
      offerId: res.data.quoteid,
      name: prodRes.data.name,
      productNumber: prodRes.data.productnumber,
      montominimo: prodRes.data.rs_montominimo,
      montomaximo: prodRes.data.rs_montomaximo,
      montoplazo: prodRes.data.rs_montoplazo,
      code: res.data.quotenumber,
      leadId: res.data._rs_prospectoid_value,
      productId: res.data._rs_productoid_value,
      amount: res.data.rs_monto,
      term: res.data.rs_plazopagos,
      ordinaryAnnualRate: res.data.rs_tasainteresanualordinariafija,
      cat: res.data.rs_catsiniva,
      payment: res.data.rs_pagofijo,
      debtInsuranceAmount: res.data.rs_montosegurodeuda,
      liberasistenciaAmount: res.data.rs_montoliberasistencia,
      liberasistenciaKind: res.data.rs_tipoliberasistencia,
      liberasistenciaTerm: res.data.rs_plazoliberasistencia,
      express: false,
      expressMaxAmount: 0,
      pprenovacion: res.data.rs_pprenovacion,
      montoserviciopreautorizado: res.data.rs_montoserviciopreautorizado,
      saldovigente: res.data.rs_saldovigente,
      aplicaExpress: res.data.rs_aplicaexpress2,
      mejorOferta: res.data.rs_mejoroferta,
      productMinimumRate: res.data.rs_productotasaminima == null ? false : res.data.rs_productotasaminima,
      monthlyTerm: res.data.rs_plazomensual,
      clubLibertadValue: res.data.rs_clublibertad,
      termClubLibertad: res.data?.rs_plazoclublibertad,
      amountClubLibertad: res.data?.rs_montoclublibertad,
      aplicaClubLibertad: prodRes.data?.rs_aplicaclublibertad
    };
  }

  public async getOfferPreautorizado(id: string): Promise<IsOfferPreautorizadoResponse> {
    const res = await this.get<IsOfferPreautorizadoResponse, AxiosResponse<ODataMultipleResponse<IsOfferPreautorizadoOData[]>>>(
      `d365api/v1/quotes?$select=quoteid&$expand=rs_productoid($select=rs_aplicapreautorizado)&$filter=_rs_prospectoid_value eq '${id}'`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let aplica = true;
    if (res.data.value != null) {
      if (res.data.value.length > 0) {
        if (res.data.value[0].rs_productoid != null) {
          aplica = res.data.value[0].rs_productoid?.rs_aplicapreautorizado ?? false;
        }
      }
    }
    return {
      producto: {
        aplicapreautorizado: aplica
      }
    };
  }

  /**
   * Updates an Offer using the specified Offer Id, Part 1 (due to Flow crap in CRM)
   *
   * @param {string} id
   * @param {Readonly<OfferUpdateRequest>} request
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public updateOfferByIdPart1(id: string, request: Readonly<OfferUpdateRequest>, projectType?: number, clientType?: number): Promise<unknown> {
    if (projectType !== 0) {
      if (clientType !== 3) {
        return this.patch<unknown, unknown, AxiosResponse<unknown>>(
          `d365api/v1/quotes(${id})`,
          {
            rs_monto: request.amount,
            rs_plazopagos: request.term,
            rs_clublibertad: request.isClubLibertad ?? false,
            rs_plazoclublibertad: request.termClubLibertad ?? 0,
            rs_montoclublibertad: request.amountClubLibertad ?? 0.0
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
            }
          }
        )
          .then(this.success)
          .catch((error: AxiosError<Error>) => {
            return Promise.reject(error);
          });
      } else {
        return this.patch<unknown, unknown, AxiosResponse<unknown>>(
          `d365api/v1/quotes(${id})`,
          {
            rs_monto: request.amount,
            rs_plazopagos: request.term,
            rs_clublibertad: request.isClubLibertad ?? false,
            rs_plazoclublibertad: request.termClubLibertad ?? 0,
            rs_montoclublibertad: request.amountClubLibertad ?? 0.0,
            rs_saldoremanente: request.remaining,
            // rs_montoliberasistencia: request.liberasistenciaAmount,
            rs_tipoliberasistencia: request.liberasistenciaKind,
            rs_plazoliberasistencia: request.liberasistenciaTerm
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
            }
          }
        )
          .then(this.success)
          .catch((error: AxiosError<Error>) => {
            return Promise.reject(error);
          });
      }
    } else {
      return this.patch<unknown, unknown, AxiosResponse<unknown>>(
        `d365api/v1/quotes(${id})`,
        {
          rs_monto: request.amount,
          rs_plazopagos: request.term
        },
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      )
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          return Promise.reject(error);
        });
    }
  }

  //Se comentan dos campos
  /**
   * Updates an Offer using the specified Offer Id, Part 2 (due to Flow crap in CRM)
   *
   * @param {string} id
   * @param {Readonly<OfferUpdateRequest>} request
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public updateOfferByIdPart2(id: string, request: Readonly<OfferUpdateRequest>): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/quotes(${id})`,
      {
        //rs_montoliberasistencia: request.liberasistenciaAmount,
        rs_tipoliberasistencia: request.liberasistenciaKind,
        rs_plazoliberasistencia: request.liberasistenciaTerm / 24
        //rs_montoserviciopreautorizado: request.montoserviciopreautorizado,
        //rs_saldovigente: request.saldovigente
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Gets the Selected Offer flag on the specified Lead Id
   *
   * @param {Readonly<string>} id
   * @returns {Promise<boolean>}
   * @memberof LeadService
   */
  public async getSelectedOffer(id: Readonly<string>): Promise<boolean> {
    const res = await this.get<{ leadid: string; rs_ofertaelegida: boolean }, AxiosResponse<{ leadid: string; rs_ofertaelegida: boolean }>>(`d365api/v1/leads(${id})?$select=leadid,rs_ofertaelegida`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });
    return res.data.rs_ofertaelegida;
  }

  /**
   * Sets the Selected Offer on the Specified Offer Id
   *
   * @param {Readonly<string>} id
   * @param {Readonly<number>} creditType
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async setSelectedOffer(id: Readonly<string>, creditType: Readonly<number>): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/quotes(${id})`,
      {
        rs_ofertaselecionada: 1, //Valor == Si
        rs_tipocreditoseleccionado: creditType // 1 = TRADITIONAL, 2 = EXPRESS
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Sets the Don't Selected Offer
   *
   * @param {OfferResponse[]} offers
   * @returns {Promise<void>}
   * @memberof LeadService
   */
  public async setNotSelectedOffers(offers: OfferResponse[]): Promise<void> {
    offers.forEach(async (offer) => {
      const response = await this.patch<unknown, unknown, AxiosResponse<unknown>>(
        `d365api/v1/quotes(${offer.offerId})`,
        {
          rs_ofertaselecionada: 0 //Valor == No
        },
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );
      return this.success(response);
    });
  }

  /**
   * Set status in desicional motor
   *
   * @param {string} id
   * @returns {Promise<void>}
   * @memberof LeadService
   */
  public async unselectOfferLead(id: string): Promise<void> {
    await this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_ofertaelegida: false
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  /**
   * Set status in desicional motor
   *
   * @param {string} id
   * @returns {Promise<void>}
   * @memberof LeadService
   */
  public async setStatusMotor(id: string): Promise<void> {
    await this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/rs_motordecisionals(${id})`,
      {
        statuscode: 717810001 /*Recalculo de ofertas */
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  /**
   * Unselect the Offer
   *
   * @param {OfferResponse} offer
   * @returns {Promise<void>}
   * @memberof LeadService
   */
  public async unselectOffer(offer: OfferResponse): Promise<void> {
    await this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/quotes(${offer.offerId})`,
      {
        rs_ofertaselecionada: null
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  /**
   * Reopen the Offer
   *
   * @param {OfferResponse} offer
   * @returns {Promise<void>}
   * @memberof LeadService
   */
  public async reopenOffer(offer: OfferResponse): Promise<void> {
    await this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/quotes(${offer.offerId})`,
      {
        statecode: 0,
        statuscode: 1,
        rs_ofertaselecionada: null
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  /**
   * Sets the Selected Offer flag on the specified Lead Id
   *
   * @param {Readonly<string>} id
   * @param {Readonly<number>} creditType
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async setSelectedOfferOnLead(id: Readonly<string>, creditType: Readonly<number>): Promise<unknown> {
    let payload: {
      rs_ofertaelegida: boolean;
      statecode?: number;
      statuscode?: number;
      rs_tipofolio?: number;
    } = {
      rs_ofertaelegida: true
    };

    // 1 = TRADITIONAL, 2 = EXPRESS
    if (creditType === 1) {
      payload = {
        rs_ofertaelegida: true,
        rs_tipofolio: 717810000
      };
    }

    return this.patch<unknown, unknown, AxiosResponse<unknown>>(`d365api/v1/leads(${id})`, payload, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async setSelectedOfferTradicionalOnLead(id: Readonly<string>, amountExceededAval: Readonly<boolean>, offer?: Readonly<OfferExceededGuarantyRequest>): Promise<unknown> {
    if (amountExceededAval) {
      await this.patch<unknown, unknown, AxiosResponse<unknown>>(
        `d365api/v1/quotes(${offer.quoteid})`,
        {
          rs_monto: offer.amount
        },
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      )
        .then(this.success)
        .catch((error: AxiosError<Error>) => {
          throw error;
        });
    }

    const payload: { rs_ofertaelegida: boolean; statecode?: number; statuscode?: number } = {
      rs_ofertaelegida: true,
      statecode: 2,
      statuscode: 717810006 // TRADITIONAL
    };
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(`d365api/v1/leads(${id})`, payload, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Gets the Lead Offer data by its Id
   *
   * @param {string} id
   * @returns {Promise<Partial<LeadOfferResponse>>}
   * @memberof LeadService
   */
  public async getLeadOffer(id: string): Promise<Partial<LeadOfferResponse>> {
    const referencias = await this.get<Partial<LeadOfferResponse>, AxiosResponse<ODataMultipleResponse<LeadOfferReferenciaODataResponse[]>>>(
      `d365api/v1/rs_referencias?$filter=_rs_prospectoid_value eq ('${id}') and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const references: LeadOfferReferenceResponse[] = [];
    referencias.data.value.forEach((r) =>
      references.push({
        firstName: r.rs_nombre,
        middleName: r.rs_segundonombre,
        lastName: r.rs_apellidopaterno,
        mothersLastName: r.rs_apellidomaterno,
        relationshipTime: r.rs_tiemporelacion,
        referenceKind: r.rs_parentesco,
        mobile: r.rs_telefonocelular,
        phone: r.rs_telefonocasa
      })
    );

    const beneficiarios = await this.get<Partial<LeadOfferResponse>, AxiosResponse<ODataMultipleResponse<LeadOfferBeneficiarioODataResponse[]>>>(
      `d365api/v1/rs_beneficiarios?$filter=_rs_prospectoid_value eq ('${id}') and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const beneficiaries: LeadOfferBeneficiaryResponse[] = [];
    beneficiarios.data.value.forEach((b) =>
      beneficiaries.push({
        firstName: b.rs_nombre,
        middleName: b.rs_segundonombre,
        lastName: b.rs_apellidopaterno,
        mothersLastName: b.rs_apellidomaterno,
        relationshipKind: b.rs_parentesco,
        birthDate: b.rs_fechanacimiento,
        birthPlaceId: b._rs_lugarnacimientoid_value,
        phone: b.rs_telefono,
        profitPercentage: b.rs_porcentajebeneficio,
        street: b.rs_calle,
        extNumber: b.rs_numeroexterior,
        intNumber: b.rs_numerointerior,
        postalCode: b.rs_codigopostal,
        street2Id: b._rs_coloniaid_value,
        cityId: b._rs_municipioid_value,
        rfc: b.rs_rfc,
        kind: b.rs_tipobeneficiario,
        id: b.rs_beneficiarioid
      })
    );

    let job: LeadOfferJobResponse | undefined;
    const res = await this.get<LeadResponse, AxiosResponse<LeadOfferDataResponse>>(
      `d365api/v1/leads(${id})?$select=_rs_empleoid_value,rs_parentescocliente,rs_parentesco1,rs_nombre1` +
        ",rs_parentescoconsejo,rs_parentesco2,rs_nombre2,rs_formaparteconsejo,rs_cargo1,rs_poseeacciones" +
        ",rs_eepecificarporcentaje,rs_accionespersonamoral,rs_denominacionsocial1,rs_consejoclienteprospecto" +
        ",rs_denominacionsocial2,rs_nombreintegranteconsejo,rs_cargo2,rs_numclientereferido" +
        ",rs_regimenpfopfae,rs_clienteactuacuentapropia,rs_dedondeprovienenlosrecursos_list" +
        ",rs_procedenciarecursoscuenta_list,rs_importeesperamanejarmes_list,rs_montodepositos_list" +
        ",rs_montoretiros_list,rs_numerodepositos_list,rs_numeroretiros_list,rs_aceptapublicidad,decisionmaker" +
        ",rs_destinorecursoscuenta,rs_instrumentomonetariomanejacuenta",
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (res.data._rs_empleoid_value) {
      const empleo = await this.get<Partial<LeadOfferResponse>, AxiosResponse<LeadOfferEmpleoODataResponse>>(`d365api/v1/rs_empleos(${res.data._rs_empleoid_value})`, {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      });
      job = {
        jobTitleId: empleo.data._rs_puestoid_value,
        economicActivityId: empleo.data._rs_actividadeconomicaid_value,
        economicSectorId: empleo.data._rs_sectoreconomicoid_value,
        incomePeriodicity: empleo.data.rs_periodicidadingresos,
        phone: empleo.data.rs_telefono,
        phoneExt: empleo.data.rs_extension,
        street: empleo.data.rs_calle,
        extNumber: empleo.data.rs_numeroexterior,
        intNumber: empleo.data.rs_numerointerior,
        postalCode: empleo.data.rs_codigopostal,
        street2Id: empleo.data._rs_coloniaid_value,
        cityId: empleo.data._rs_municipioid_value,
        stateId: empleo.data._rs_entidadfederativaid_value,
        Id: ""
      };
    }
    const lsfLink: LeadOfferLibertadRelationResponse = {
      //pregunta1
      relationWithCustomer: res.data.rs_parentescocliente,
      relationWithCustomerKind: res.data.rs_parentesco1,
      relationWithCustomerName: res.data.rs_nombre1,
      //pregunta2
      relationWithCompany: res.data.rs_parentescoconsejo,
      relationWithCompanyKind: res.data.rs_parentesco2,
      relationWithCompanyName: res.data.rs_nombre2,
      //pregunta3
      partOfCompany: res.data.rs_formaparteconsejo,
      partOfCompanyPosition: res.data.rs_cargo1,
      //pregunta4
      shareholder: res.data.rs_poseeacciones,
      shareholderPercentage: res.data.rs_eepecificarporcentaje,
      //pregunta5
      shareholderMoralPerson: res.data.rs_accionespersonamoral,
      shareholderMoralPersonSocialDenomination: res.data.rs_denominacionsocial1,
      //pregunta6
      shareholderCustomer: res.data.rs_consejoclienteprospecto,
      shareholderCustomerSocialDenomination: res.data.rs_denominacionsocial2,
      shareholderCustomerName: res.data.rs_nombreintegranteconsejo,
      shareholderCustomerPosition: res.data.rs_cargo2,
      //afiliación
      regime: res.data.rs_regimenpfopfae,
      freeWill: res.data.rs_clienteactuacuentapropia,
      accountResource: res.data.rs_dedondeprovienenlosrecursos_list,
      accountMaintenance: res.data.rs_procedenciarecursoscuenta_list,
      amountPerMonthres: res.data.rs_importeesperamanejarmes_list,
      depositAmount: res.data.rs_montodepositos_list,
      withdrawalAmount: res.data.rs_montoretiros_list,
      depositNumber: res.data.rs_numerodepositos_list,
      withdrawalNumber: res.data.rs_numeroretiros_list,
      acceptAdvertising: res.data.rs_aceptapublicidad,
      decisionmaker: res.data.decisionmaker,
      purposeResource: res.data.rs_destinorecursoscuenta,
      monetaryInstrument: res.data.rs_instrumentomonetariomanejacuenta
    };

    const referred: ReferredClientResponse = {
      clientNumber: res.data.rs_numclientereferido
    };

    return {
      references: references,
      beneficiaries: beneficiaries,
      job: job,
      lsfLink: lsfLink,
      referred: referred
    };
  }

  public async getBeneficiaries(id: string): Promise<LeadOfferBeneficiaryResponse[]> {
    const beneficiarios = await this.get<Partial<LeadOfferResponse>, AxiosResponse<ODataMultipleResponse<LeadOfferBeneficiarioODataResponse[]>>>(
      `d365api/v1/rs_beneficiarios?$filter=_rs_solicitudid_value eq ('${id}') and statecode eq 0`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const beneficiaries: LeadOfferBeneficiaryResponse[] = [];
    beneficiarios.data.value.forEach((b) =>
      beneficiaries.push({
        firstName: b.rs_nombre,
        middleName: b.rs_segundonombre,
        lastName: b.rs_apellidopaterno,
        mothersLastName: b.rs_apellidomaterno,
        relationshipKind: b.rs_parentesco,
        birthDate: b.rs_fechanacimiento,
        birthPlaceId: b._rs_lugarnacimientoid_value,
        phone: b.rs_telefono,
        profitPercentage: b.rs_porcentajebeneficio,
        street: b.rs_calle,
        extNumber: b.rs_numeroexterior,
        intNumber: b.rs_numerointerior,
        postalCode: b.rs_codigopostal,
        street2Id: b._rs_coloniaid_value,
        cityId: b._rs_municipioid_value,
        rfc: b.rs_rfc,
        kind: b.rs_tipobeneficiario,
        id: b.rs_beneficiarioid
      })
    );
    return beneficiaries;
  }

  /**
   * Creates a new Lead
   *
   * @param {Readonly<LeadRequest>} request
   * @returns {Promise<string>}
   * @memberof LeadService
   */
  public async create(request: Readonly<LeadRequest>): Promise<string> {
    if (request.ownerId !== undefined) {
      const res = await this.post<LeadHeadODataResponse, unknown, AxiosResponse<LeadHeadODataResponse>>(
        "d365api/v1/leads",
        {
          "rs_finalidadid@odata.bind": `/rs_finalidads(${request.purposeId})`,
          // "rs_comprobanteingresosid@odata.bind": `/rs_tipodocumentos(${request.incomeProofId})`,
          "ownerid@odata.bind": `/systemusers(${request.ownerId})`,
          "rs_usuarioportalcallcenterid@odata.bind": `/rs_usuarioportalcallcenters(${request.userId})`,
          rs_montorequerido: request.requestedAmount,
          rs_plazoquincenal: request.selectedPeriod,
          rs_pagofijo: request.fixedRecurrentPayment,
          rs_catsiniva: request.calculatedCat,
          firstname: request.firstName,
          rs_segundonombre: request.middleName,
          middlename: request.lastName,
          lastname: request.mothersLastName,
          //rs_fechanacimiento: request.birthDate,
          emailaddress1: request.email,
          mobilephone: request.mobile,
          rs_tipoproceso: 1,
          rs_tipocliente: 2,
          rs_origenprospecto: 3, //request.origin
          "rs_tipoingreso@odata.bind": `/rs_tipodeingresos(${request.incomeTypeId})`,
          rs_mostrartabdatospersonales: true,
          rs_finalidaddelosrecursos: request.purposeResources,
          rs_validarmediocontacto: 1
        },
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );
      return res.data.leadid;
    } else {
      const res = await this.post<LeadHeadODataResponse, unknown, AxiosResponse<LeadHeadODataResponse>>(
        "d365api/v1/leads",
        {
          "rs_finalidadid@odata.bind": `/rs_finalidads(${request.purposeId})`,
          "rs_usuarioportalcallcenterid@odata.bind": `/rs_usuarioportalcallcenters(${request.userId})`,
          // "rs_comprobanteingresosid@odata.bind": `/rs_tipodocumentos(${request.incomeProofId})`,
          rs_montorequerido: request.requestedAmount,
          rs_plazoquincenal: request.selectedPeriod,
          rs_pagofijo: request.fixedRecurrentPayment,
          rs_catsiniva: request.calculatedCat,
          firstname: request.firstName,
          rs_segundonombre: request.middleName,
          middlename: request.lastName,
          lastname: request.mothersLastName,
          //rs_fechanacimiento: request.birthDate,
          emailaddress1: request.email,
          mobilephone: request.mobile,
          rs_tipoproceso: 1,
          rs_tipocliente: 2,
          "rs_tipoingreso@odata.bind": `/rs_tipodeingresos(${request.incomeTypeId})`,
          rs_mostrartabdatospersonales: true,
          rs_finalidaddelosrecursos: request.purposeResources
        },
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );
      return res.data.leadid;
    }
  }

  /**
   * Updates a Lead with Personal data
   *
   * @param {string} id
   * @param {Readonly<LeadGeneralRequest>} request
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public updatePersonalData(id: string, request: Readonly<LeadGeneralRequest>): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_genero: request.genre,
        rs_codigoverificador: request.nip,
        "rs_lugarnacimientoid@odata.bind": `/rs_entidadfederativas(${request.birthPlaceId})`,
        rs_nacionalidad: request.nationality ?? 1,
        telephone2: request.phone,
        "rs_nivelestudios@odata.bind": `/rs_nivelestudioses(${request.educationLevelId})`,
        rs_curp: request.curp,
        rs_rfc: request.rfc,
        "rs_paisnacimiento@odata.bind": `/rs_paises(${request.birthCountryId})`,
        rs_fechanacimiento: request.birthDay,
        rs_mostrartabvivienda: true,
        rs_instrumentomonetariomanejacuenta: request.monetaryInstrument
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Updates a Lead with Living Place data
   *
   * @param {string} id
   * @param {Readonly<LeadLivingPlaceRequest>} request
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public updateLivingPlaceData(id: string, request: Readonly<LeadLivingPlaceRequest>): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        address1_line1: request.street,
        address1_line2: request.extNumber,
        address1_line3: request.intNumber,
        address1_postalcode: request.postalCode,
        "rs_coloniaid@odata.bind": `/rs_colonias(${request.street2Id})`,
        "rs_municipioid@odata.bind": `/rs_municipios(${request.cityId})`,
        "rs_estadoid@odata.bind": `/rs_entidadfederativas(${request.stateId})`,
        rs_antiguedadciudad: request.yearsAtCity,
        rs_antiguedadvivienda: request.yearsAtHome,
        "rs_tipovivienda@odata.bind": `/rs_tipodeviviendas(${request.propertyKindId})`,
        rs_montorenta: request.rentAmount,
        "rs_sucursalprospectoid@odata.bind": `/rs_sucursals(${request.branchId})`,
        rs_horariocontacto: request.contactSchedule,
        rs_estadocivil: request.maritalStatus,
        rs_dependienteseconomicos1: request.economicDependents,
        rs_mostrartabempleo: true
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Creates a Spouse and links it to the Lead
   *
   * @param {string} leadId
   * @param {Readonly<LeadSpouseRequest>} spouse
   * @returns {Promise<string>}
   * @memberof LeadService
   */
  public async createSpouse(leadId: string, spouse: Readonly<LeadSpouseRequest>): Promise<string> {
    const existant = await this.get<{ rs_conyugeid: string; _rs_prospectoid_value: string }, AxiosResponse<ODataMultipleResponse<{ rs_conyugeid: string; _rs_prospectoid_value: string }[]>>>(
      `d365api/v1/rs_conyuges?$select=rs_conyugeid,_rs_prospectoid_value&$filter=rs_curp eq '${spouse.curp}' and _rs_prospectoid_value eq ('${leadId}')`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (existant.data.value.length > 0) {
      return existant.data.value[0].rs_conyugeid;
    }

    const res = await this.post<ConyugeODataResponse, unknown, AxiosResponse<ConyugeODataResponse>>(
      "d365api/v1/rs_conyuges?$select=rs_conyugeid",
      {
        "rs_prospectoid@odata.bind": `/leads(${leadId})`,
        rs_nombre: spouse.firstName,
        rs_segundonombre: spouse.middleName,
        rs_apellidopaterno: spouse.lastName,
        rs_apellidomaterno: spouse.mothersLastName,
        rs_fechanacimiento: spouse.birthDate,
        rs_genero: spouse.genre,
        rs_nacionalidad: spouse.nationality,
        "rs_lugarnacimientoid@odata.bind": `/rs_entidadfederativas(${spouse.birthPlaceId})`,
        rs_curp: spouse.curp,
        rs_rfc: spouse.rfc,
        "rs_ocupacionid@odata.bind": `/rs_ocupacions(${spouse.occupationId})`,
        "rs_regimenmatrimonial@odata.bind": `/rs_regimenmatrimonials(${spouse.matrimonialRegimeId})`
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    await this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${leadId})`,
      {
        "rs_conyugeid@odata.bind": `/rs_conyuges(${res.data.rs_conyugeid})`
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.rs_conyugeid;
  }

  /**
   * Updates a Lead with Job data
   *
   * @param {string} id
   * @param {Readonly<LeadJobRequest>} request
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public updateJobData(id: string, request: Readonly<LeadJobRequest>, bcAuth: boolean): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        "rs_profesionid@odata.bind": `/rs_profesions(${request.professionId})`,
        "rs_ocupacionid@odata.bind": `/rs_ocupacions(${request.occupationId})`,
        rs_nombreempresa: request.companyName,
        rs_antiguedadempresa: request.yearsAtWork,
        rs_nss: request.ssn,
        rs_ingresosfijos: request.fixedIncome,
        rs_ingresosvariables: request.variableIncome,
        rs_mostrartaboferta: true,
        rs_continuarmismoingreso: request.continueSameIncome,
        rs_nombrepatron: request.patternName,
        rs_salariobasecotizacion: request.salaryQuote,
        rs_estadoempleado: request.employedStatus,
        rs_fechaingreso: request.admissionDate,
        rs_fechabaja: request.lowDate,
        "rs_actividadeconomicaid@odata.bind": `/rs_actividadeconomicas(${request.economicActivityId})`,
        "rs_sectoreconomicoid@odata.bind": `/rs_sectoreconomicos(${request.economicSectorId})`,
        "rs_actividadbanxicoid@odata.bind": `/rs_actividadbanxicos(${request.banxicoActivity})`,
        "rs_puestoid@odata.bind": `/rs_puestos(${request.positionId})`
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Gets the number of retries of the day for the Credit Bureau
   *
   * @param {string} id
   * @returns {Promise<number>}
   * @memberof LeadService
   */
  public async getCreditBureauRetries(id: string): Promise<number> {
    // FIXME: Should not send request 'as is' since it can be modified and nip verification excluded, it should also be a POST method
    const res = await this.get<{ rs_intentosautenticacionbc?: number; rs_fechaautenticacionbc: string }, AxiosResponse<{ rs_intentosautenticacionbc?: number; rs_fechaautenticacionbc: string }>>(
      `d365api/v1/leads(${id})?$select=leadid,rs_intentosautenticacionbc,rs_fechaautenticacionbc,rs_buroautenticado`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (dayjs(res.data.rs_fechaautenticacionbc).isToday()) {
      return res.data.rs_intentosautenticacionbc ?? 0;
    } else {
      return 0;
    }
  }

  /**
   * Gets the value of rs_bcautenticado for the Lead
   *
   * @param {string} id
   * @returns {Promise<boolean>}
   * @memberof LeadService
   */
  public async getCreditBureauAuth(id: string): Promise<boolean> {
    // FIXME: Should not send request 'as is' since it can be modified and nip verification excluded, it should also be a POST method
    const res = await this.get<{ rs_bcautenticado?: boolean }, AxiosResponse<{ rs_bcautenticado?: boolean }>>(`d365api/v1/leads(${id})?$select=rs_bcautenticado`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    return res.data.rs_bcautenticado == null ? false : res.data.rs_bcautenticado;
  }

  /**
   * Updates a Lead with the Credit Bureau Authorization data
   *
   * @param {string} id
   * @param {Readonly<LeadCreditBureauRequest>} request
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public updateCreditBureauAuthorization(id: string, request: Readonly<LeadCreditBureauRequest>): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_creditohipotecario: request.hasMortageCredit,
        rs_creditoautomotriz: request.hasAutomotiveCredit,
        rs_cuentatarjetacredito: request.hasValidCreditCard,
        rs_ultimos4digitostc: request.lastFourDigitsOfCreditCard
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Updates a Lead with a flag from the result of the Credit Bureau Authorization
   *
   * @param {string} id
   * @param {number} authOption
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public creditBureauAuthorized(id: string, authOption: number): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_bcautenticado: true,
        rs_metodoconsulta: authOption
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Update Referred Client in Lead
   *
   * @param {string} id
   * @param {string} referredClient
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async updateReferredClient(id: string, referredClient: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_numclientereferido: referredClient
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Creates a list of References and links it to the Lead
   *
   * @param {string} leadId
   * @param {Readonly<LeadReferenceRequest[]>} references
   * @returns {Promise<string[]>}
   * @memberof LeadService
   */
  public async createReferences(leadId: string, references: Readonly<LeadReferenceRequest[]>): Promise<string[]> {
    // FIXME: It would be ideal to send them all as an array (batch op), requires backend
    const ids: string[] = [];
    references.forEach(async (r) => {
      const existant = await this.get<{ rs_referenciaid: string }, AxiosResponse<ODataMultipleResponse<{ rs_referenciaid: string }[]>>>(
        `d365api/v1/rs_referencias?$select=rs_referenciaid,_rs_prospectoid_value&$filter=rs_nombre eq '${r.firstName}' and rs_apellidopaterno eq '${r.lastName}' and _rs_prospectoid_value eq ('${leadId}')`,
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );

      if (existant.data.value.length > 0) {
        ids.push(existant.data.value[0].rs_referenciaid);
      } else {
        const res = await this.post<ReferenciaODataResponse, unknown, AxiosResponse<ReferenciaODataResponse>>(
          "d365api/v1/rs_referencias?$select=rs_referenciaid",
          {
            "rs_prospectoid@odata.bind": `/leads(${leadId})`,
            rs_nombre: r.firstName,
            rs_segundonombre: r.middleName,
            rs_apellidopaterno: r.lastName,
            rs_apellidomaterno: r.mothersLastName,
            rs_tiemporelacion: r.relationshipTime,
            rs_parentesco: r.referenceKind,
            rs_telefonocelular: r.mobile,
            rs_telefonocasa: r.phone
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
            }
          }
        );
        ids.push(res.data.rs_referenciaid);
      }
    });
    return ids;
  }

  /**
   * Creates a list of Beneficiaries and links it to the Lead
   *
   * @param {string} leadId
   * @param {Readonly<LeadBeneficiaryRequest[]>} beneficiaries
   * @returns {Promise<string[]>}
   * @memberof LeadService
   */
  public async createBeneficiaries(leadId: string, beneficiaries: Readonly<LeadBeneficiaryRequest[]>): Promise<string[]> {
    // FIXME: It would be ideal to send them all as an array (batch op), requires backend
    const ids: string[] = [];
    beneficiaries.forEach(async (b) => {
      const existant = await this.get<{ rs_beneficiarioid: string }, AxiosResponse<ODataMultipleResponse<{ rs_beneficiarioid: string }[]>>>(
        `d365api/v1/rs_beneficiarios?$select=rs_beneficiarioid,_rs_solicitudid_value&$filter=rs_nombre eq '${b.firstName}' and rs_apellidopaterno eq '${b.lastName}' and rs_parentesco eq ${b.relationshipKind} and _rs_prospectoid_value eq ('${leadId}')`,
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );

      if (existant.data.value.length > 0) {
        ids.push(existant.data.value[0].rs_beneficiarioid);
      } else {
        const res = await this.post<BeneficiarioODataResponse, unknown, AxiosResponse<BeneficiarioODataResponse>>(
          "d365api/v1/rs_beneficiarios?$select=rs_beneficiarioid",
          {
            "rs_prospectoid@odata.bind": `/leads(${leadId})`,
            rs_nombre: b.firstName,
            rs_segundonombre: b.middleName,
            rs_apellidopaterno: b.lastName,
            rs_apellidomaterno: b.mothersLastName,
            rs_fechanacimiento: b.birthDate,
            "rs_lugarnacimientoid@odata.bind": `/rs_entidadfederativas(${b.birthPlaceId})`,
            rs_parentesco: b.relationshipKind,
            rs_rfc: b.rfc,
            rs_telefono: b.phone,
            rs_calle: b.street,
            rs_numeroexterior: b.extNumber,
            rs_numerointerior: b.intNumber,
            rs_codigopostal: b.postalCode,
            "rs_coloniaid@odata.bind": `/rs_colonias(${b.street2Id})`,
            "rs_municipioid@odata.bind": `/rs_municipios(${b.cityId})`,
            rs_porcentajebeneficio: b.profitPercentage,
            rs_tipobeneficiario: b.beneficiaryKind
          },
          {
            headers: {
              "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
            }
          }
        );
        ids.push(res.data.rs_beneficiarioid);
      }
    });
    return ids;
  }

  /**
   * Creates a list of Beneficiaries and links it to the Lead
   *
   * @param {string} opportunityId
   * @param {Readonly<LeadBeneficiaryRequest[]>} beneficiaries
   * @returns {Promise<string[]>}
   * @memberof LeadService
   */
  public async updateBeneficiaries(opportunityId: string, beneficiaries: Readonly<LeadBeneficiaryRequest[]>): Promise<string[]> {
    const ids: string[] = [];
    beneficiaries.forEach(async (b) => {
      // const existant = await this.get<{ rs_beneficiarioid: string }, AxiosResponse<ODataMultipleResponse<{ rs_beneficiarioid: string }[]>>>(
      //   `d365api/v1/rs_beneficiarios?$select=rs_beneficiarioid,_rs_prospectoid_value&$filter=rs_nombre eq '${b.firstName}' and rs_apellidopaterno eq '${b.lastName}' and rs_parentesco eq ${b.relationshipKind} and _rs_solicitudid_value eq ('${opportunityId}')`
      // );
      // if (existant.data.value.length > 0) {
      const res = await this.patch<BeneficiarioODataResponse, unknown, AxiosResponse<BeneficiarioODataResponse>>(
        `d365api/v1/rs_beneficiarios(${b.id})?$select=rs_beneficiarioid`,
        {
          rs_nombre: b.firstName,
          rs_segundonombre: b.middleName,
          rs_apellidopaterno: b.lastName,
          rs_apellidomaterno: b.mothersLastName,
          rs_fechanacimiento: b.birthDate,
          "rs_lugarnacimientoid@odata.bind": `/rs_entidadfederativas(${b.birthPlaceId})`,
          rs_parentesco: b.relationshipKind,
          rs_rfc: b.rfc,
          rs_telefono: b.phone,
          rs_calle: b.street,
          rs_numeroexterior: b.extNumber,
          rs_numerointerior: b.intNumber,
          rs_codigopostal: b.postalCode,
          "rs_coloniaid@odata.bind": `/rs_colonias(${b.street2Id})`,
          "rs_municipioid@odata.bind": `/rs_municipios(${b.cityId})`,
          rs_porcentajebeneficio: b.profitPercentage,
          rs_tipobeneficiario: b.beneficiaryKind
        },
        {
          headers: {
            "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
          }
        }
      );
      ids.push(res.data.rs_beneficiarioid);
      // }
    });

    return ids;
  }

  /**
   * Creates a Job Detail and links it to the Lead
   *
   * @param {string} leadId
   * @param {Readonly<LeadJobDetailsRequest>} job
   * @returns {Promise<string>}
   * @memberof LeadService
   */
  public async createJobDetails(leadId: string, job: Readonly<LeadJobDetailsRequest>): Promise<string> {
    const res = await this.post<EmpleoODataResponse, unknown, AxiosResponse<EmpleoODataResponse>>(
      "d365api/v1/rs_empleos?$select=rs_empleoid",
      {
        "rs_prospectoid@odata.bind": `/leads(${leadId})`,
        "rs_puestoid@odata.bind": `/rs_empleos(${job.jobTitleId})`,
        "rs_actividadeconomicaid@odata.bind": `/rs_actividadeconomicas(${job.economicActivityId})`,
        "rs_sectoreconomicoid@odata.bind": `/rs_sectoreconomicos(${job.economicSectorId})`,
        rs_periodicidadingresos: job.incomePeriodicity,
        rs_telefono: job.phone,
        rs_extension: job.phoneExt,
        rs_calle: job.street,
        rs_numeroexterior: job.extNumber,
        rs_numerointerior: job.intNumber,
        rs_codigopostal: job.postalCode,
        "rs_coloniaid@odata.bind": `/rs_colonias(${job.street2Id})`,
        "rs_municipioid@odata.bind": `/rs_municipios(${job.cityId})`,
        "rs_entidadfederativaid@odata.bind": `/rs_entidadfederativas(${job.stateId})`
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    await this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${leadId})`,
      {
        "rs_empleoid@odata.bind": `/rs_empleos(${res.data.rs_empleoid})`
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.rs_empleoid;
  }

  public async updateJobDetails(empleoId: string, job: Readonly<LeadJobDetailsRequest>): Promise<string> {
    const res = await this.patch<EmpleoODataResponse, unknown, AxiosResponse<EmpleoODataResponse>>(
      `d365api/v1/rs_empleos(${empleoId})?$select=rs_empleoid`,
      {
        "rs_puestoid@odata.bind": `/rs_empleos(${job.jobTitleId})`,
        "rs_actividadeconomicaid@odata.bind": `/rs_actividadeconomicas(${job.economicActivityId})`,
        "rs_sectoreconomicoid@odata.bind": `/rs_sectoreconomicos(${job.economicSectorId})`,
        rs_periodicidadingresos: job.incomePeriodicity,
        rs_telefono: job.phone,
        rs_extension: job.phoneExt,
        rs_calle: job.street,
        rs_numeroexterior: job.extNumber,
        rs_numerointerior: job.intNumber,
        rs_codigopostal: job.postalCode,
        "rs_coloniaid@odata.bind": `/rs_colonias(${job.street2Id})`,
        "rs_municipioid@odata.bind": `/rs_municipios(${job.cityId})`,
        "rs_entidadfederativaid@odata.bind": `/rs_entidadfederativas(${job.stateId})`
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data.rs_empleoid;
  }

  public async getJobByOpportunity(id: string): Promise<LeadOfferJobResponse> {
    const empleo = await this.get<Partial<LeadOfferResponse>, AxiosResponse<ODataMultipleResponse<LeadOfferEmpleoODataResponse[]>>>(
      `d365api/v1/rs_empleos?$select=_rs_prospectoid_value,rs_telefono,rs_empleoid,_rs_entidadfederativaid_value,rs_codigopostal,_rs_coloniaid_value,_rs_municipioid_value,rs_name,_rs_puestoid_value,rs_numeroexterior,rs_periodicidadingresos,_rs_sectoreconomicoid_value,rs_calle,_rs_actividadeconomicaid_value,rs_numerointerior,rs_extension&$filter=(_rs_solicitudid_value eq ${id})`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return {
      jobTitleId: empleo.data.value[0]._rs_puestoid_value,
      economicActivityId: empleo.data.value[0]._rs_actividadeconomicaid_value,
      economicSectorId: empleo.data.value[0]._rs_sectoreconomicoid_value,
      incomePeriodicity: empleo.data.value[0].rs_periodicidadingresos,
      phone: empleo.data.value[0].rs_telefono,
      phoneExt: empleo.data.value[0].rs_extension,
      street: empleo.data.value[0].rs_calle,
      extNumber: empleo.data.value[0].rs_numeroexterior,
      intNumber: empleo.data.value[0].rs_numerointerior,
      postalCode: empleo.data.value[0].rs_codigopostal,
      street2Id: empleo.data.value[0]._rs_coloniaid_value,
      cityId: empleo.data.value[0]._rs_municipioid_value,
      stateId: empleo.data.value[0]._rs_entidadfederativaid_value,
      Id: empleo.data.value[0].rs_empleoid
    };
  }

  /**
   * Updates a Lead with Libertad Relation data
   *
   * @param {string} id
   * @param {Readonly<LeadLibertadRelationRequest>} request
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public updateLibertadRelationData(id: string, request: Readonly<LeadLibertadRelationRequest>): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        //pregunta1
        rs_parentescocliente: request.relationWithCustomer,
        rs_parentesco1: request.relationWithCustomerKind,
        rs_nombre1: request.relationWithCustomerName,
        //pregunta2
        rs_parentescoconsejo: request.relationWithCompany,
        rs_parentesco2: request.relationWithCompanyKind,
        rs_nombre2: request.relationWithCompanyName,
        //pregunta3
        rs_formaparteconsejo: request.partOfCompany,
        rs_cargo1: request.partOfCompanyPosition,
        //pregunta4
        rs_poseeacciones: request.shareholder,
        rs_eepecificarporcentaje: request.shareholderPercentage,
        //pregunta5
        rs_accionespersonamoral: request.shareholderMoralPerson,
        rs_denominacionsocial1: request.shareholderMoralPersonSocialDenomination,
        //pregunta6
        rs_consejoclienteprospecto: request.shareholderCustomer,
        rs_denominacionsocial2: request.shareholderCustomerSocialDenomination,
        rs_nombreintegranteconsejo: request.shareholderCustomerName,
        rs_cargo2: request.shareholderCustomerPosition
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public updateLibertadAfilacionData(id: string, request: Readonly<LeadLibertadRelationRequest>): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_regimenpfopfae: request.regime,
        rs_clienteactuacuentapropia: request.freeWill,
        rs_dedondeprovienenlosrecursos_list: request.accountResource,
        rs_procedenciarecursoscuenta_list: request.accountMaintenance,
        rs_importeesperamanejarmes_list: request.amountPerMonth,
        rs_montodepositos_list: request.depositAmount,
        rs_montoretiros_list: request.withdrawalAmount,
        rs_numerodepositos_list: request.depositNumber,
        rs_numeroretiros_list: request.withdrawalNumber,
        rs_aceptapublicidad: request.acceptAdvertising,
        decisionmaker: request.decisionmaker,
        rs_destinorecursoscuenta: request.purposeResource,
        rs_instrumentomonetariomanejacuenta: request.monetaryInstrument
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  /**
   * Creates an Annotation and links it to the Lead
   *
   * @param {string} leadId
   * @param {Readonly<LeadAnnotation>} annotation
   * @returns {Promise<string>}
   * @memberof LeadService
   */
  public async createAnnotation(id: string, annotation: Readonly<LeadAnnotation>): Promise<string> {
    const res = await this.post<AnnotationODataResponse, unknown, AxiosResponse<AnnotationODataResponse>>(
      "d365api/v1/annotations?$select=annotationid",
      {
        "objectid_lead@odata.bind": `/leads(${id})`,
        subject: annotation.subject,
        notetext: annotation.description,
        filename: `EXPEDIENTE_${annotation.filename}`,
        // isdocument: true,
        documentbody: annotation.base64
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.annotationid;
  }

  /**
   * Triggers the Credit Request on the Lead
   *
   * @param {string} id
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async triggerCreditRequest(id: string, incomeProofId?: string): Promise<unknown> {
    let request;
    if (incomeProofId) {
      request = {
        //rs_domicilioine: 1,
        rs_detonasolicitudcredito: true,
        "rs_comprobanteingresosid@odata.bind": `/rs_tipodocumentos(${incomeProofId})`
      };
    } else {
      request = {
        //rs_domicilioine: 1,
        rs_detonasolicitudcredito: true
      };
    }

    return this.patch<unknown, unknown, AxiosResponse<unknown>>(`d365api/v1/leads(${id})`, request, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Returns a value indicating if the Proof of ID (front) document is valid.
   *
   * @param {string} content
   * @returns {Promise<boolean>}
   * @memberof LeadService
   */
  public async validateProofIdFront(content: Readonly<string>): Promise<boolean> {
    const res = await this.post<{ response: boolean }, unknown, AxiosResponse<{ response: boolean }>>(
      `Flows/v1/workflows/${FLOW_VAL_ID_URL}/triggers/manual/paths/invoke`,
      {
        image: content
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.response;
  }

  /**
   * Returns a value indicating if the Proof of Address document is valid.
   *
   * @param {string} type
   * @param {string} content
   * @returns {Promise<boolean>}
   * @memberof LeadService
   */
  /*public async validateProofAddress(type: Readonly<string>, content: Readonly<string>): Promise<boolean> {
    const res = await this.post<{ Regla1: boolean; Regla2: boolean }, unknown, AxiosResponse<{ Regla1: boolean; Regla2: boolean }>>(
      `Flows/v1/workflows/${FLOW_VAL_ADDR_URL}/triggers/manual/paths/invoke`,
      {
        type: type,
        image: content
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.Regla1 && res.data.Regla2;
  }*/

  /**
   * Gets the PDF document as Base64 of the Credit Request.
   *
   * @param {string} id
   * @returns {Promise<string>}
   * @memberof LeadService
   */
  public async getCreditRequestPdf(id: Readonly<string>, entidad: string): Promise<string> {
    const res = await this.post<{ Content: string }, unknown, AxiosResponse<{ Content: string }>>(
      `Flows/v1/workflows/${FLOW_CRED_REQ_PDF_URL}/triggers/manual/paths/invoke`,
      {
        guid: id,
        entidad: entidad
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.Content;
  }

  /**
   * Triggers the Credit Rejected event on the Lead
   *
   * @param {string} id
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async triggerCreditRejected(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        statecode: 2,
        statuscode: 717810007
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Triggers the Credit End event on the Lead
   *
   * @param {string} id
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async triggerCreditEnd(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_detonasolicitud: true
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Triggers the Rechazo Oferta event on the Lead
   *
   * @param {string} id
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async triggerRechazoOferta(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_detonaflowrechazooferta: true
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  public async disqualifyLead(id: string, status: number): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        statecode: 2,
        statuscode: status
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        throw error;
      });
  }

  /**
   * Updates an Offer using the specified Offer Id, Part 1 (due to Flow crap in CRM)
   *
   * @param {string} id
   * @param {Readonly<LeadHeadODataResponse>} request
   * @returns {Promise<unknown>}
   * @memberof LeadService
   */
  public async updateVerificatorCode(id: string, nip: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_codigoverificador: nip
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async updateVirtualCurrency(id: string, haveVirtualCurrency: boolean, typeCurrency: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_monedavirtual: typeCurrency,
        rs_operacionesmonedasvirtuales: haveVirtualCurrency
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async createPreauthorizedClient(customerNumber: string): Promise<string> {
    const res = await this.post<LeadPreauthorizedODataResponse, unknown, AxiosResponse<LeadPreauthorizedODataResponse>>(
      "d365api/v1/leads",
      {
        rs_numeroclientelibertad: customerNumber,
        rs_buscarcliente: true,
        rs_origenprospecto: 3
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data.rs_folio;
  }

  public async createAppoinment(appointment: Appointment, ownerId: string, telephone: string, leadId: string, branch: string): Promise<string> {
    const start = appointment.scheduledstart.replace("/", "-");
    const end = appointment.scheduledend.replace("/", "-");
    const res = await this.post<AppointmentODataResponse, unknown, AxiosResponse<AppointmentODataResponse>>(
      "d365api/v1/appointments",
      {
        subject: appointment.subject,
        description: appointment.description,
        scheduledstart: start + "T12:00:00.238Z", //appointment.scheduledstart,
        scheduledend: end + "T12:00:00.238Z", //appointment.scheduledend,
        rs_origenprospecto: 3,
        "ownerid@odata.bind": `/systemusers(${ownerId})`,
        rs_telefonocelular: telephone,
        "regardingobjectid_lead_appointment@odata.bind": `/leads(${leadId})`,
        rs_banderacallcenter: true,
        "rs_sucursalcitaid_Appointment@odata.bind": "/rs_sucursals(" + branch + ")"
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data.appointmentid;
  }

  // public async getPhone(leadid: string): Promise<string> {
  //   const res = await this.get<{ _rs_sucursalprospectoid_value: string; mobilephone: string }, AxiosResponse<{ _rs_sucursalprospectoid_value: string; mobilephone: string }>>(
  //     `d365api/v1/leads(${leadid})`,
  //     {
  //       headers: {
  //         "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
  //       }
  //     }
  //   );

  //   return res.data.mobilephone;
  // }

  public async getSystemUserId(domainName: string): Promise<string> {
    const res = await this.get<SystemUserODataResponse, AxiosResponse<ODataMultipleResponse<SystemUserODataResponse[]>>>(`d365apis/v1/systemusers?domainname='${domainName}'`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    return res.data.value[0].systemuserid;
  }

  // public async changeOwner(ownerId: string, id: string): Promise<unknown> {
  //   return this.patch<unknown, unknown, AxiosResponse<unknown>>(
  //     `d365api/v1/leads(${id})`,
  //     {
  //       "ownerid@odata.bind": `/systemusers(${ownerId})`
  //     },
  //     {
  //       headers: {
  //         "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
  //       }
  //     }
  //   )
  //     .then(this.success)
  //     .catch((error: AxiosError<Error>) => {
  //       throw error;
  //     });
  // }

  /**
   * Find data for appointment
   *
   * @param {string} leadId
   * @returns {(Promise<LeadUserResponse>)}
   * @memberof LeadService
   */
  public async getUserId(leadId: string): Promise<LeadUserResponse> {
    const res = await this.get<LeadUserODataResponse, AxiosResponse<ODataMultipleResponse<LeadUserODataResponse[]>>>(
      `d365api/v1/leads?$select=mobilephone,rs_folio&$expand=rs_sucursalprospectoid($select=_rs_gerentesucursalid_value)&$filter=leadid eq ${leadId}`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const user = res.data.value[0];
    const data: LeadUserResponse = {
      phone: user.mobilephone,
      number: user.rs_folio,
      managerId: user.rs_sucursalprospectoid?._rs_gerentesucursalid_value
    };
    return data;
  }

  /**
   * Sends an SMS to the specified Lead ID.
   *
   * @param {string} leadId
   * @param {string} nipField
   * * @param {string} nameVariable
   * @returns {(Promise<string | undefined>)}
   * @memberof LeadService
   */
  public async sendSmsCustom(leadId: string, nipField: string, nameVariable: string): Promise<void> {
    // FIXME: This shouldn't be done like this but as I mentioned several times, there's no backend for the frontend ¯\(°_o)/¯
    const res = await this.get<
      { mobilephone: string; rs_nipenviado: string; rs_nipautorizacionbc: string; rs_nipautorizacionsc: string },
      AxiosResponse<{ mobilephone: string; rs_nipenviado: string; rs_nipautorizacionbc: string; rs_nipautorizacionsc: string }>
    >(`d365api/v1/leads(${leadId})?$select=leadid,mobilephone,rs_nipenviado,rs_nipautorizacionbc,rs_nipautorizacionsc`, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    let nip = "";
    let tag = "";
    if (nipField === "nipautorizacionbc") {
      nip = res.data.rs_nipautorizacionbc;
      tag = "bc";
    } else if (nipField === "nipautorizacionsc") {
      nip = res.data.rs_nipautorizacionsc;
      tag = "sc";
    } else if (nipField === "nipenviado") {
      nip = res.data.rs_nipenviado;
      tag = "new";
    }

    const messageSms = await variablesService.findMessageSms(nameVariable);
    await this.post<unknown, unknown, AxiosResponse<unknown>>(
      "v1",
      {
        message: `${messageSms} ${nip}`,
        msisdns: [`52${res.data.mobilephone}`],
        tag: tag
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
  }

  /**
   * Validate if TL contains MOP 99
   *
   * @param {string} id
   * @returns {(Promise<boolean>)}
   * @memberof LeadService
   */
  public async validateMop99(id: string): Promise<boolean> {
    const res = await this.get<{ leadid: string }, AxiosResponse<ODataMultipleResponse<{ leadid: string }[]>>>(
      `d365api/v1/leads?fetchXml=%3Cfetch%3E%3Centity%20name%3D%22lead%22%20%3E%3Cattribute%20name%3D%22leadid%22%20%2F%3E%3Cfilter%20type%3D%22and%22%20%3E%3Ccondition%20attribute%3D%22leadid%22%20operator%3D%22eq%22%20value%3D%22${id}%22%20%2F%3E%3Ccondition%20entityname%3D%22rs_tl%22%20attribute%3D%22rs_mop%22%20operator%3D%22eq%22%20value%3D%2299%22%20%2F%3E%3Ccondition%20entityname%3D%22rs_consultaburocredito%22%20attribute%3D%22statecode%22%20operator%3D%22eq%22%20value%3D%220%22%20%2F%3E%3Ccondition%20entityname%3D%22rs_intl%22%20attribute%3D%22statecode%22%20operator%3D%22eq%22%20value%3D%220%22%20%2F%3E%3Ccondition%20entityname%3D%22rs_tl%22%20attribute%3D%22statecode%22%20operator%3D%22eq%22%20value%3D%220%22%20%2F%3E%3C%2Ffilter%3E%3Clink-entity%20name%3D%22rs_consultaburocredito%22%20from%3D%22rs_consultaburoid%22%20to%3D%22leadid%22%20link-type%3D%22inner%22%20%3E%3Clink-entity%20name%3D%22rs_intl%22%20from%3D%22rs_consultaburoid%22%20to%3D%22rs_consultaburocreditoid%22%20link-type%3D%22inner%22%20%3E%3Clink-entity%20name%3D%22rs_tl%22%20from%3D%22rs_intlid%22%20to%3D%22rs_intlid%22%20link-type%3D%22inner%22%20%2F%3E%3C%2Flink-entity%3E%3C%2Flink-entity%3E%3C%2Fentity%3E%3C%2Ffetch%3E`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.value[0]?.leadid ? true : false;
  }

  /*public async resultMotorMessage(id: string): Promise<MotorMessageResponse> {
    const response = await this.get<MotorMessageResponse, AxiosResponse<DesitionalMotorODataResponse>>(
      `d365api/v1/leads(${id})?$select=leadid&$expand=rs_registromotordecisionalid($select=rs_mensajemotor,rs_resultadomotor)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return {
      motorMessage: response.data?.rs_registromotordecisionalid?.rs_mensajemotor,
      motorResult: response.data?.rs_registromotordecisionalid?.rs_resultadomotor
    };
  }*/

  public async updateCustomerInquiry(id: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_detonaconsultacliente: true,
        rs_mostrartabvivienda: true
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async getMotorResult(id: string): Promise<MotorResultResponse> {
    const response = await this.get<MotorResultResponse, AxiosResponse<DesitionalMotorODataResponse>>(
      `d365api/v1/leads(${id})?$select=leadid&$expand=rs_registromotordecisionalid($select=rs_ofertaminima)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const result: MotorResultResponse = {
      minimumOffer: response.data?.rs_registromotordecisionalid?.rs_ofertaminima,
      desicionalMotorId: response.data?.rs_registromotordecisionalid?.rs_motordecisionalid
    };

    return result;
  }

  public async getRejectMessageMotor(id: string): Promise<MotorMessageErrorResponse> {
    const response = await this.get<MotorMessageErrorResponse, AxiosResponse<DesitionalMotorErrorODataResponse>>(
      `d365api/v1/leads(${id})?$select=leadid&$expand=rs_registromotordecisionalid($select=rs_motordecisionalid,rs_resultadomotor,_rs_mensajeerrorburoid_value;$expand=rs_mensajeerrorburoid($select=rs_name))`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    const result: MotorMessageErrorResponse = {
      motorResult: response.data?.rs_registromotordecisionalid?.rs_resultadomotor,
      motorErrorMessage: response.data?.rs_registromotordecisionalid?.rs_mensajeerrorburoid?.rs_name,
      rs_motordecisionalid: response.data?.rs_registromotordecisionalid?.rs_motordecisionalid
    };

    return result;
  }

  public async getAmountClubLibertad(): Promise<number> {
    const response = await this.get<{ rs_montototal: number }, AxiosResponse<ODataMultipleResponse<{ rs_montototal: number }[]>>>(
      `d365api/v1/rs_clublibertads?$select=rs_montototal&$filter= statecode eq 0&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return response.data.value[0].rs_montototal;
  }

  public async createScheduleNuevoDigital(investigation: Readonly<ScheduleInvestigationRequest>, id: string): Promise<unknown> {
    const response = await this.patch<ScheduleInvestigation, unknown, AxiosResponse<ScheduleInvestigationRequest>>(
      `d365api/v1/leads(${id})`,
      {
        rs_deseaagregarcomentariovisitainvestigacion: investigation.addComments === 1 ? true : false,
        rs_horainiciovisitainvestigacion: investigation.startSchedule,
        rs_horafinvisitainvestigacion: investigation.endSchedule,
        rs_comentariosvisitainvestigacion: investigation.comments
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return response.data;
  }

  public async updateLeadConsultation(id: string, value: any): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_consulta_nss: value
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async updateLeadContinueSameIncome(id: string, value: any): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_continuarmismoingreso: value
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async updateLeadEmployed(id: string, value: any): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_estadoempleado: value
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async updateLeadNewFixedIncome(id: string, value: any): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        rs_ingresosvariables: value
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async getEconomicActivity(id: string): Promise<EconomicActivityResponse[]> {
    const res = await this.get<EconomicActivityResponse, AxiosResponse<ODataMultipleResponse<EconActODataResponse[]>>>(
      `d365api/v1/leads?$select=_rs_actividadbanxicoid_value,_rs_actividadeconomicaid_value,_rs_ocupacionid_value,_rs_puestoid_value,_rs_sectoreconomicoid_value&$filter=(leadid eq '${id}')`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    const data: EconomicActivityResponse[] = [];
    res.data.value.forEach((elem) => {
      data.push({
        ocupacion: elem._rs_ocupacionid_value,
        actbanxico: elem._rs_actividadbanxicoid_value,
        puesto: elem._rs_puestoid_value,
        acteconomica: elem._rs_actividadeconomicaid_value,
        secteconomico: elem._rs_sectoreconomicoid_value
      });
    });
    return data;
  }

  public async updatePhone(id: string, phone: string): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(
      `d365api/v1/leads(${id})`,
      {
        mobilephone: phone
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    )
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async validateLogs(id: string, entidad: string): Promise<boolean> {
    const res = await this.post<TwilioResponse, unknown, AxiosResponse<TwilioRespODataResponse>>(
      "flows-portal/v1/validate-logs-twilio",
      {
        id: id,
        entidad: entidad
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.valid;
  }

  public async detonatePlugin(id: string, request: any): Promise<unknown> {
    return this.patch<unknown, unknown, AxiosResponse<unknown>>(`d365api/v1/leads(${id})`, request, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }

  public async getVerificacion(id: string, paso: string): Promise<PhoneVerification> {
    const res = await this.get<PhoneVerificationODataResponse, AxiosResponse<ODataMultipleResponse<PhoneVerificationODataResponse[]>>>(
      `d365api/v1/rs_verificaciontelefonomovils?$select=statuscode,rs_intentosvalidacionnumcel&$filter=(_rs_prospecto_value eq ${id} and rs_pasodelenviosms eq ${paso})&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    let result = null;
    if (res.data?.value != null && res.data.value.length > 0) {
      result = {
        intentos: res.data.value[0].rs_intentosvalidacionnumcel,
        statuscode: res.data.value[0].statuscode
      };
    } else {
      result = {
        intentos: 0,
        statuscode: 0
      };
    }

    return result;
  }

  public async getURLDocs(id: string): Promise<string> {
    const res = await this.get<{ rs_ligadocumentosperfilamiento?: string }, AxiosResponse<{ rs_ligadocumentosperfilamiento?: string }>>(
      `d365api/v1/leads(${id})?$select=rs_ligadocumentosperfilamiento`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data?.rs_ligadocumentosperfilamiento;
  }

  public async getDocumentKindsLead(id: string): Promise<DocumentKindResponse[]> {
    const res = await this.get<TipoDocumentoODataResponse, AxiosResponse<ODataMultipleResponse<TipoDocumentoODataResponse[]>>>(
      `d365api/v1/rs_expedientes?$select=rs_name&$expand=rs_tipodocumentoid($select=rs_id)&$filter=(startswith(rs_name, 'Identificacion+Oficial') and statuscode ne 2) and (rs_prospectoid/leadid eq ${id}) and (rs_tipodocumentoid/rs_tipodocumentoid ne null)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    const data: DocumentKindResponse[] = [];
    if (res.data?.value != null && res.data.value.length > 0) {
      res.data.value.forEach((elem) => {
        data.push({
          id: elem.rs_expedienteid,
          code: elem.rs_tipodocumentoid.rs_id,
          name: elem.rs_name
        });
      });
    }
    return data;
  }

  public async ConsultaClienteLibertad(request: any): Promise<ConsultaClienteResponse> {
    const res = await this.post<ConsultaClienteResponse, unknown, AxiosResponse<ConsultaClienteResponse>>("flows-portal/v1/consulta-cliente-libertad", request, {
      headers: {
        "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
      }
    });

    return res.data;
  }

  public async getContactProfiling(id: string): Promise<Partial<LeadClientExistantRequest>> {
    const res = await this.get<Partial<ContactProfilingODataResponse>, AxiosResponse<ContactProfilingODataResponse>>(
      `d365api/v1/contacts(${id})?$select=address1_line1,address1_line2,address1_line3,address1_postalcode,emailaddress1,familystatuscode,firstname` +
        `,gendercode,lastname,middlename,mobilephone,_rs_colonia_value,rs_curp,rs_destinorecursoscuenta,_rs_estadoid_value` +
        `,rs_instrumentomonetariomanejaracuentas,_rs_municipioid_value,rs_numerocliente,_rs_paisdenacimiento_value,rs_rfc,telephone2,contactid,rs_segundonombre`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return {
      contactId: res.data.contactid,
      firstName: res.data.firstname,
      middleName: res.data.rs_segundonombre,
      lastName: res.data.middlename,
      mothersLastName: res.data.lastname,
      birthDay: res.data.birthdate,
      phone: res.data.mobilephone,
      email: res.data.emailaddress1,
      rfc: res.data.rs_rfc,
      curp: res.data.rs_curp,
      clientNumber: res.data.rs_numerocliente,
      country: res.data._rs_paisdenacimiento_value,
      delegationState: res.data._rs_estadoid_value,
      city: res.data._rs_municipioid_value,
      cologne: res.data._rs_colonia_value,
      gender: res.data.gendercode,
      purposeResources: res.data.rs_destinorecursoscuenta,
      monetaryInstrument: res.data.rs_instrumentomonetariomanejaracuentas,
      street: res.data.address1_line1,
      cp: res.data.address1_postalcode,
      street2: res.data.address1_line2,
      street3: res.data.address1_line3,
      phone2: res.data.telephone2,
      maritalStatus: res.data.familystatuscode
    };
  }

  //public async createExistantClient(response: Partial<LeadClientExistantRequest>): Promise<string> {
  public async createExistantClient(numeroCliente: string): Promise<string> {
    const res = await this.post<LeadHeadODataResponse, unknown, AxiosResponse<LeadHeadODataResponse>>(
      "d365api/v1/leads",
      {
        // middlename: response.middleName,
        // emailaddress1: response.email,
        statuscode: 1,
        // rs_regimenpfopfae: false,
        // lastname: response.lastName,
        // firstname: response.firstName,
        // mobilephone: response.phone,
        // address1_line1: response.street,
        // address1_postalcode: response.cp,
        // rs_curp: response.curp,
        rs_numeroclientelibertad: numeroCliente,
        // address1_line2: response.street2,
        // address1_line3: response.street3,
        // "rs_estado@odata.bind": response.delegationState ? `/rs_entidadfederativas(${response.delegationState})` : null,
        // "rs_municipioid@odata.bind": response.city ? `/rs_municipios(${response.city})` : null,
        // "rs_coloniaid@odata.bind": response.cologne ? `/rs_colonias(${response.cologne})` : null,
        // rs_rfc: response.rfc,
        // rs_genero: response.gender,
        // telephone2: response.phone2,
        // "rs_paisnacimiento@odata.bind": response.country ? `/rs_paises(${response.country})` : null,
        // rs_estadocivil: response.maritalStatus,
        // rs_destinorecursoscuenta: response.purposeResources,
        // rs_instrumentomonetariomanejacuenta: response.monetaryInstrument,
        // rs_tipocliente: 1,
        rs_buscarcliente: true,
        rs_origenprospecto: 3
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.leadid;
  }

  public async getLogsPLD(id: string): Promise<LogPLD> {
    const res = await this.get<Partial<LogPLD>, AxiosResponse<ODataMultipleResponse<LogPLD>>>(
      `d365api/v1/rs_logservicioses?$select=rs_response,rs_confirmamensajepld,rs_stateendpoint&$expand=rs_prospectoid($select=leadid)&` +
        `$filter=(statecode eq 0 and rs_tiposervicio eq 717810001) and ` +
        `(rs_prospectoid/rs_tipocliente eq 2 or rs_prospectoid/rs_tipocliente eq 1) and ` +
        `(rs_prospectoid/rs_tipoproyecto eq 1 or rs_prospectoid/rs_tipoproyecto eq 0) and (rs_prospectoid/leadid eq ${id})&$orderby=createdon desc`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    return res.data?.value[0];
  }

  public async getLogsPLDCount(id: string): Promise<number> {
    const res = await this.get<ODataMultipleResponse<number>, AxiosResponse<ODataMultipleResponse<number>>>(
      `d365api/v1/rs_logservicioses?$select=rs_response&$expand=rs_prospectoid($select=leadid)&` +
        `$filter=(rs_tiposervicio eq 717810001) and ` +
        `(rs_prospectoid/rs_tipocliente eq 2 or rs_prospectoid/rs_tipocliente eq 1) and ` +
        `(rs_prospectoid/rs_tipoproyecto eq 1 or rs_prospectoid/rs_tipoproyecto eq 0) and (rs_prospectoid/leadid eq ${id})`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );

    if (res.data?.value && Array.isArray(res.data.value)) return res.data.value.length;

    return 0;
  }

  public async createDigitalNew(numeroCliente: string): Promise<string> {
    const res = await this.post<LeadHeadODataResponse, unknown, AxiosResponse<LeadHeadODataResponse>>(
      "d365api/v1/leads",
      {
        statuscode: 1,
        rs_buscarcliente: true,
        rs_numeroclientelibertad: numeroCliente,
        rs_origenprospecto: 3,
        rs_tipoproyecto: 1
      },
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    return res.data.leadid;
  }

  public async findUniquePhone(request: Readonly<LeadPrincipalImssRequest>): Promise<any> {
    const res = await this.get<LeadHeadODataResponse, AxiosResponse<ODataMultipleResponse<LeadHeadODataResponse[]>>>(
      `d365api/v1/leads?$select=leadid,rs_folio,rs_origen,_rs_sucursalid_value&$filter=(rs_curp eq '${request.curp}' or rs_rfc eq '${request.rfc}' or mobilephone eq '${request.mobile}' or emailaddress1 eq '${request.email}') and (statecode eq 0)`,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      }
    );
    if (res.data?.value != null && res.data.value.length > 0) return { folio: res.data.value[0]?.rs_folio, origen: res.data.value[0]?.rs_origen, sucursal: res.data.value[0]?._rs_sucursalid_value };
    else return null;
  }
}

export const leadService = new LeadService();
